(function() {
  let cart = [];
  let activeSlide = 0;
  let currentProductInModal = null;
  let modalQty = 1;
  let selectedColor = null;
  let selectedSize = null;

  function initStorefront() {
    // Inject dynamic product page dark mode styling
    if (document.querySelector('.product') || window.location.pathname.includes('/products/')) {
      const prodStyle = document.createElement('style');
      prodStyle.id = 'dynamic-product-dark-mode-override';
      prodStyle.textContent = `
        body, html, main, #MainContent, .product, .shopify-section, [class*="color-scheme-"], .gradient, .isolate {
          --color-background: 8, 8, 10 !important;
          --gradient-background: #08080a !important;
          --color-foreground: 255, 255, 255 !important;
          background-color: #08080a !important;
          color: #ffffff !important;
        }
        .product *, .product__info-container *, .product__info-wrapper *, .product-form *, .product__title, .product__title *, .product-title {
          color: #ffffff !important;
        }
        .price, .price *, .price-item, .price-item *, .product .price, .product .price * {
          color: #d4af37 !important;
          font-weight: 900 !important;
        }
        .product-form__submit, button[name="add"], .product-form button[type="submit"], .product-form__buttons button {
          background: linear-gradient(135deg, #f9f5e8 0%, #d4af37 40%, #b8860b 100%) !important;
          color: #000000 !important;
          font-weight: 900 !important;
        }
        .product-form__submit *, button[name="add"] *, .product-form button[type="submit"] * {
          color: #000000 !important;
        }
        .form__label, .product-form__input .form__label, .product-form__input legend, legend.form__label, .variant-picker .form__label {
          color: #ffffff !important;
          font-family: 'Plus Jakarta Sans', system-ui, sans-serif !important;
          font-size: 14px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 1px !important;
          margin-bottom: 10px !important;
          display: block !important;
          opacity: 1 !important;
        }
        .form__label span, .product-form__input .form__label span, legend.form__label span, .variant-picker .form__label span {
          color: #d4af37 !important;
          font-weight: 900 !important;
          margin-left: 6px !important;
          text-shadow: 0 0 12px rgba(212, 175, 55, 0.4) !important;
        }
        .product-form__input label, fieldset.product-form__input label, .variant-picker label {
          background-color: #15151a !important;
          color: #ffffff !important;
          border: 1px solid rgba(255, 255, 255, 0.2) !important;
          border-radius: 8px !important;
          padding: 10px 20px !important;
          font-weight: 700 !important;
          font-size: 13px !important;
          transition: all 0.25s ease !important;
          cursor: pointer !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .product-form__input label:hover, fieldset.product-form__input label:hover {
          border-color: #d4af37 !important;
          color: #d4af37 !important;
          transform: translateY(-2px) !important;
        }
        .product-form__input input[type='radio']:checked + label, fieldset.product-form__input input[type='radio']:checked + label {
          background: linear-gradient(135deg, #f9f5e8 0%, #d4af37 40%, #b8860b 100%) !important;
          color: #000000 !important;
          font-weight: 900 !important;
          border: none !important;
          box-shadow: 0 4px 14px rgba(212, 175, 55, 0.4) !important;
        }
        .product-form__input input[type='radio']:checked + label *, fieldset.product-form__input input[type='radio']:checked + label * {
          color: #000000 !important;
          font-weight: 900 !important;
        }
      `;
      document.head.appendChild(prodStyle);
    }
  // Inject dynamic collection page price color & layout styling (bypasses Shopify CSS limitations)
  const style = document.createElement('style');
  style.id = 'dynamic-collection-price-style';
  style.textContent = `
    /* Only style the collection banner section background (the first section inside main) */
    main[data-template="collection"] .shopify-section:first-of-type,
    main[data-template="collection"] .shopify-section:first-of-type .section,
    main[data-template="collection"] .shopify-section:first-of-type .custom-section-content {
      background-color: #08080a !important;
      border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
    }
    main[data-template="collection"] .section-content-wrapper h1 {
      font-weight: 800 !important;
      font-size: 2.8rem !important;
      letter-spacing: 0.05em !important;
      color: #d4af37 !important;
      font-family: 'Cinzel', serif !important;
      margin-bottom: 15px !important;
    }
    main[data-template="collection"] .rte,
    main[data-template="collection"] .rte p {
      font-size: 1.05rem !important;
      line-height: 1.7 !important;
      color: rgba(255, 255, 255, 0.7) !important;
      max-width: 800px !important;
      margin-top: 10px !important;
    }
    /* Force grid list container to stretch all items in each row to equal height */
    main[data-template="collection"] ul.grid,
    main[data-template="collection"] ul.product-grid {
      align-items: stretch !important;
    }
    /* Force all grid items and their wrapper divs to stretch to 100% height */
    main[data-template="collection"] li.product-grid__item,
    main[data-template="collection"] .product-grid__item,
    main[data-template="collection"] .grid__item {
      height: auto !important; /* Allow natural stretch height */
      display: flex !important;
      flex-direction: column !important;
      align-items: stretch !important;
    }
    main[data-template="collection"] .product-card-wrapper,
    main[data-template="collection"] .card-wrapper,
    main[data-template="collection"] .product-grid__item > div,
    main[data-template="collection"] .grid__item > div {
      height: 100% !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: stretch !important;
      flex-grow: 1 !important;
    }
    main[data-template="collection"] product-card,
    main[data-template="collection"] .product-card {
      background-color: #15151a !important;
      border: 1px solid rgba(255, 255, 255, 0.06) !important;
      border-radius: 16px !important;
      padding: 10px !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: stretch !important; /* Stretch child containers to full width */
      text-align: left !important;
      box-sizing: border-box !important;
      flex-grow: 1 !important; /* Stretch card to fill grid item height */
      transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
    }
    main[data-template="collection"] product-card:hover,
    main[data-template="collection"] .product-card:hover {
      transform: translateY(-4px) !important;
      border-color: #d4af37 !important;
      box-shadow: 0 8px 24px rgba(212, 175, 55, 0.15) !important;
    }
    main[data-template="collection"] .product-card__content,
    main[data-template="collection"] .product-grid__card {
      background: transparent !important;
      border: none !important;
      padding: 0 !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: stretch !important;
      flex-grow: 1 !important;
      height: 100% !important;
      width: 100% !important; /* Force full width of the card */
    }
    /* Force left-alignment on all elements inside the product card */
    main[data-template="collection"] product-card,
    main[data-template="collection"] .product-card,
    main[data-template="collection"] product-card *,
    main[data-template="collection"] .product-card * {
      text-align: left !important;
    }
    /* Force left-alignment, stretch layout, and block styling on title links and text blocks */
    main[data-template="collection"] product-card [ref="productTitleLink"],
    main[data-template="collection"] product-card [ref="productTitleLink"] div,
    main[data-template="collection"] product-card [ref="productTitleLink"] p,
    main[data-template="collection"] product-card [class*="product_title"],
    main[data-template="collection"] product-card [class*="product_title"] p,
    main[data-template="collection"] product-card .rte,
    main[data-template="collection"] product-card .rte p,
    main[data-template="collection"] product-card .text-block,
    main[data-template="collection"] product-card .text-block p {
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      align-self: stretch !important; /* Stretch to fill card width */
      width: 100% !important;
      max-width: none !important; /* Override theme max-width */
      --max-width: none !important; /* Override custom property max-width */
      margin-left: 0 !important;
      margin-right: auto !important;
    }
    /* Specific product title style: dark, bold, 13px size, and clamped to 2 lines */
    main[data-template="collection"] product-card [ref="productTitleLink"] [class*="product_title"],
    main[data-template="collection"] product-card [ref="productTitleLink"] [class*="product_title"] p,
    main[data-template="collection"] product-card [class*="product_title"],
    main[data-template="collection"] product-card [class*="product_title"] p {
      color: #ffffff !important;
      font-weight: 600 !important;
      font-size: 13px !important;
      line-height: 1.3 !important;
      height: auto !important;
      min-height: 40px !important;
      overflow: hidden !important;
      display: -webkit-box !important;
      -webkit-line-clamp: 2 !important;
      -webkit-box-orient: vertical !important;
    }
    /* Target price component host element, align to bottom, and force left alignment */
    main[data-template="collection"] product-card product-price,
    main[data-template="collection"] product-card .text-block.h6.spacing-style[data-product-id] {
      display: flex !important; /* Force block to allow flex alignment */
      flex-direction: column !important;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      --color: #d4af37 !important;
      --color-foreground: 212, 175, 55 !important;
      color: #d4af37 !important;
      margin-top: auto !important; /* Push price to the bottom */
      padding-top: 12px !important;
      padding-left: 0 !important;
      text-align: left !important;
      width: 100% !important;
    }
    /* Styled price size inside collection cards (refined to be slightly smaller) */
    main[data-template="collection"] product-card .price,
    main[data-template="collection"] product-card .price-item,
    main[data-template="collection"] product-card span.price,
    main[data-template="collection"] product-card .price__container {
      color: #d4af37 !important;
      font-weight: 700 !important;
      font-size: 14px !important;
      text-align: left !important;
      display: flex !important;
      flex-direction: row !important;
      justify-content: flex-start !important;
      align-items: center !important;
      margin-left: 0 !important;
      margin-right: auto !important;
    }
    /* Strict vertical left alignment for title and price inner elements */
    main[data-template="collection"] product-card [ref="productTitleLink"] *,
    main[data-template="collection"] product-card [class*="product_title"] *,
    main[data-template="collection"] product-card product-price *,
    main[data-template="collection"] product-card .price * {
      margin-left: 0 !important;
      margin-right: auto !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      text-align: left !important;
    }
    /* Global price color override (safe for homepage) */
    .price-current {
      color: #d4af37 !important;
    }
    /* Shopify Dynamic Checkout More Payment Options Link Styling */
    .shopify-payment-button__more-options,
    .shopify-payment-button__more-options[aria-disabled="true"],
    .shopify-payment-button__more-options:hover,
    .shopify-payment-button__more-options:focus,
    [class*="payment-button"] button[class*="more-options"] {
      color: #d4af37 !important;
      text-decoration: underline !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      margin-top: 10px !important;
      display: block !important;
      width: 100% !important;
      text-align: center !important;
      opacity: 1 !important;
      visibility: visible !important;
      background: transparent !important;
      border: none !important;
      cursor: pointer !important;
      transition: all 0.2s ease !important;
      font-family: inherit !important;
    }
    .shopify-payment-button__more-options:hover {
      color: #ffffff !important;
      text-shadow: 0 0 10px rgba(212, 175, 55, 0.5) !important;
    }
  `;
  document.head.appendChild(style);

  let shopifyProductsMap = {};
  let wishlist = JSON.parse(localStorage.getItem('mockWishlist') || '[]');

  // --- Pure Client-Side Mock Cart Fallback (when Shopify Catalog is empty) ---
  let mockCart = JSON.parse(localStorage.getItem('mockCart') || '[]');

  function saveMockCart() {
    try {
      localStorage.setItem('mockCart', JSON.stringify(cart));
      localStorage.setItem('aura_cart', JSON.stringify(cart));
      localStorage.setItem('inklooma_cart', JSON.stringify(cart));
      localStorage.setItem('auraCart', JSON.stringify(cart));
    } catch(e) {}
    window.cart = cart;
  }

  // Intercept window.fetch to support client-side mock cart when Shopify catalog is empty
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
    
    // Spy on real Shopify add-to-cart requests to slide open the custom Cart Drawer
    if (urlStr && (urlStr.includes('/cart/add.js') || urlStr.includes('/cart/add'))) {
      return originalFetch(url, options).then(response => {
        if (response.ok) {
          const clonedResponse = response.clone();
          setTimeout(() => {
            if (typeof window.refreshAuraCartData === 'function') {
              window.refreshAuraCartData();
            } else if (typeof updateCartUI === 'function') {
              updateCartUI();
            }

            if (typeof window.openAuraCart === 'function') {
              window.openAuraCart();
            } else if (typeof openCart === 'function') {
              openCart();
            }
          }, 350);
          return clonedResponse;
        }
        return response;
      });
    }

    const isLocal = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost' || window.location.protocol.startsWith('file');
    if (!isLocal) {
      return originalFetch(url, options);
    }
    
    // Check if the catalog is empty
    const catalogIsEmpty = Object.keys(shopifyProductsMap).length === 0;
    
    if (catalogIsEmpty && urlStr && (
      urlStr.includes('/cart/add.js') || 
      urlStr.includes('/cart.js') || 
      urlStr.includes('/cart/change.js') || 
      urlStr.includes('/cart/clear.js')
    )) {
      console.log(`[Mock Cart] Intercepted request to: ${urlStr}`);
      
      if (urlStr.includes('/cart/add.js')) {
        let body = {};
        try { body = JSON.parse(options.body); } catch(e) {}
        
        const qty = body.quantity || 1;
        const mockProduct = productsData[currentProductInModal ? currentProductInModal.id : 1];
        
        if (mockProduct) {
          const itemKey = `${mockProduct.id}_${selectedColor || 'Default'}_${selectedSize || 'Default'}`;
          const existingItem = mockCart.find(item => item.key === itemKey);
          
          if (existingItem) {
            existingItem.quantity += qty;
          } else {
            mockCart.push({
              key: itemKey,
              id: mockProduct.id,
              title: mockProduct.title,
              vendor: mockProduct.vendor,
              price: mockProduct.price * 100, // cents
              image: mockProduct.image,
              quantity: qty,
              variant_title: `${selectedColor || 'Default'} / ${selectedSize || 'Default'}`,
              options_with_values: [
                { name: 'Color', value: selectedColor || 'Default' },
                { name: 'Size', value: selectedSize || 'Default' }
              ]
            });
          }
          saveMockCart();
        }
        
        return Promise.resolve(new Response(JSON.stringify({
          item_count: mockCart.reduce((sum, item) => sum + item.quantity, 0)
        }), { status: 200 }));
      }
      
      if (urlStr.includes('/cart.js')) {
        const totalItems = mockCart.reduce((sum, item) => sum + item.quantity, 0);
        const totalPrice = mockCart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        
        return Promise.resolve(new Response(JSON.stringify({
          item_count: totalItems,
          total_price: totalPrice,
          items: mockCart
        }), { status: 200 }));
      }
      
      if (urlStr.includes('/cart/change.js')) {
        let body = {};
        try { body = JSON.parse(options.body); } catch(e) {}
        
        const line = body.line;
        if (line !== undefined) {
          const idx = line - 1;
          const qty = body.quantity;
          if (mockCart[idx]) {
            if (qty <= 0) {
              mockCart.splice(idx, 1);
            } else {
              mockCart[idx].quantity = qty;
            }
            saveMockCart();
          }
        }
        
        const totalItems = mockCart.reduce((sum, item) => sum + item.quantity, 0);
        const totalPrice = mockCart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        
        return Promise.resolve(new Response(JSON.stringify({
          item_count: totalItems,
          total_price: totalPrice,
          items: mockCart
        }), { status: 200 }));
      }
      
      if (urlStr.includes('/cart/clear.js')) {
        mockCart = [];
        saveMockCart();
        return Promise.resolve(new Response(JSON.stringify({
          item_count: 0,
          total_price: 0,
          items: []
        }), { status: 200 }));
      }
    }
    
    return originalFetch(url, options).then(response => {
      if (urlStr && (
        urlStr.includes('/cart/add.js') ||
        urlStr.includes('/cart/change.js') ||
        urlStr.includes('/cart/clear.js')
      )) {
        if (response.ok) {
          console.log(`[Mock Cart] Intercepted successful native cart action: ${urlStr}`);
          setTimeout(() => {
            updateCartUI();
            openCart();
          }, 400);
        }
      }
      return response;
    });
  };

  // Dynamic Products Database (Auto-populated 100% from Shopify Admin)
  const productsData = {};

  async function syncShopifyCatalog() {
    try {
      let shopifyProductsList = [];
      if (window.auraShopifyProducts && Array.isArray(window.auraShopifyProducts) && window.auraShopifyProducts.length > 0) {
        shopifyProductsList = window.auraShopifyProducts;
      } else {
        try {
          let response = await fetch('products.json');
          if (!response.ok) {
            response = await fetch('/products.json?limit=250');
          }
          if (response.ok) {
            const data = await response.json();
            if (data && data.products) {
              shopifyProductsList = data.products;
            }
          }
        } catch(e) {}
      }

      if (shopifyProductsList.length > 0) {
        const normalizeStr = (str) => (str || '').toLowerCase().replace(/[^a-z0-9]/g, '');

        shopifyProductsList.forEach((sp, idx) => {
          const pId = sp.id || (idx + 1);
          shopifyProductsMap[sp.title.toLowerCase().trim()] = sp;
          shopifyProductsMap[sp.handle] = sp;
          shopifyProductsMap[normalizeStr(sp.title)] = sp;
          shopifyProductsMap[normalizeStr(sp.handle)] = sp;

          const priceVal = parseFloat(sp.price || (sp.variants && sp.variants[0] ? sp.variants[0].price : 0)) || 0;
          const compareVal = parseFloat(sp.compare_at_price || (sp.variants && sp.variants[0] ? sp.variants[0].compare_at_price : 0)) || 0;
          let mainImg = sp.featured_image;
          if (typeof mainImg !== 'string') mainImg = mainImg ? (mainImg.src || mainImg) : '';
          if (!mainImg && sp.images && sp.images.length > 0) {
            const firstImg = sp.images[0];
            mainImg = typeof firstImg === 'string' ? firstImg : (firstImg.src || firstImg);
          }
          let hoverImg = mainImg;
          if (sp.images && sp.images.length > 1) {
            const secondImg = sp.images[1];
            hoverImg = typeof secondImg === 'string' ? secondImg : (secondImg.src || secondImg);
          }

          productsData[pId] = {
            id: pId,
            title: sp.title,
            vendor: sp.vendor || '',
            category: (sp.product_type || sp.category || 'all').toLowerCase(),
            price: priceVal,
            originalPrice: compareVal > priceVal ? compareVal : null,
            image: mainImg,
            hoverImage: hoverImg,
            reviewsCount: 20 + (idx * 7) % 150,
            rating: 5,
            desc: sp.description || sp.title,
            realProduct: sp,
            systemTitle: sp.title
          };
        });

        console.log('[Shopify Sync Engine] Successfully auto-synced', shopifyProductsList.length, 'real Shopify Admin products!');
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function() {
            if (typeof renderProducts === 'function') renderProducts();
            if (typeof initDynamicHeroSlider === 'function') initDynamicHeroSlider();
          });
        } else {
          if (typeof renderProducts === 'function') renderProducts();
          if (typeof initDynamicHeroSlider === 'function') initDynamicHeroSlider();
        }
      }
    } catch(err) {
      console.warn('[Shopify Sync Engine] Offline/Local demo mode active:', err.message);
    }
  }

  // Trigger sync on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncShopifyCatalog);
  } else {
    syncShopifyCatalog();
  }

  // Track scroll position before locking body
  let lastScrollY = 0;
  function saveScrollPosition() {
    if (document.body.style.overflow !== 'hidden') {
      lastScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    }
  }
  function restoreScrollPosition() {
    window.scrollTo({
      top: lastScrollY,
      behavior: 'auto'
    });
  }

  // --- DOM Elements ---
  const siteHeader = document.getElementById('siteHeader');
  const slides = document.querySelectorAll('.slide');
  const sliderDots = document.querySelectorAll('.slider-dot');
  const sliderPrevBtn = document.getElementById('sliderPrevBtn');
  const sliderNextBtn = document.getElementById('sliderNextBtn');
  const tabBtns = document.querySelectorAll('.tab-btn');
  var productsGrid = document.getElementById('productsGrid');
  
  // Cart DOM
  const cartToggleBtn = document.getElementById('cartToggleBtn');
  const cartCloseBtn = document.getElementById('cartCloseBtn');
  const cartOverlay = document.getElementById('cartOverlay');
  const cartDrawer = document.getElementById('cartDrawer');
  const emptyCartState = document.getElementById('emptyCartState');
  const cartItemsList = document.getElementById('cartItemsList');
  const cartDrawerFooter = document.getElementById('cartDrawerFooter');
  const cartSubtotalPrice = document.getElementById('cartSubtotalPrice');
  const cartCountBadges = [
    document.getElementById('cartCount'),
    document.getElementById('cartCountHeader')
  ];
  const continueShoppingBtn = document.getElementById('continueShoppingBtn');
  const checkoutBtn = document.getElementById('checkoutBtn');

  // Quick View DOM
  const quickViewOverlay = document.getElementById('quickViewOverlay');
  const modalCloseBtn = document.getElementById('modalCloseBtn');
  const modalProductImage = document.getElementById('modalProductImage');
  const modalProductVendor = document.getElementById('modalProductVendor');
  const modalProductTitle = document.getElementById('modalProductTitle');
  const modalProductRatingReviews = document.getElementById('modalProductRatingReviews');
  const modalProductPriceCurrent = document.getElementById('modalProductPriceCurrent');
  const modalProductPriceOriginal = document.getElementById('modalProductPriceOriginal');
  const modalProductDesc = document.getElementById('modalProductDesc');
  const modalQtyVal = document.getElementById('modalQtyVal');
  const modalQtyMinus = document.getElementById('modalQtyMinus');
  const modalQtyPlus = document.getElementById('modalQtyPlus');
  const modalAddToCartBtn = document.getElementById('modalAddToCartBtn');

  // Checkout DOM
  const checkoutOverlay = document.getElementById('checkoutOverlay');
  const checkoutModal = document.getElementById('checkoutModal');
  const checkoutCloseBtn = document.getElementById('checkoutCloseBtn');
  const checkoutForm = document.getElementById('checkoutForm');
  const checkoutItemsList = document.getElementById('checkoutItemsList');
  const checkoutSubtotal = document.getElementById('checkoutSubtotal');
  const checkoutGrandTotal = document.getElementById('checkoutGrandTotal');
  const checkoutTaxes = document.getElementById('checkoutTaxes');
  const paymentOptCard = document.getElementById('paymentOptCard');
  const paymentOptCOD = document.getElementById('paymentOptCOD');
  const cardDetailsSection = document.getElementById('cardDetailsSection');
  const checkoutGrid = document.getElementById('checkoutGrid');
  const checkoutSuccessSection = document.getElementById('checkoutSuccessSection');
  const checkoutSuccessCloseBtn = document.getElementById('checkoutSuccessCloseBtn');

  const successOrderNumber = document.getElementById('successOrderNumber');
  const successEmail = document.getElementById('successEmail');
  const successName = document.getElementById('successName');
  const successAddress = document.getElementById('successAddress');
  const successPaymentMethod = document.getElementById('successPaymentMethod');

  // --- Sticky Header Scroll Effect ---
  window.addEventListener('scroll', () => {
    if (!siteHeader) return;
    if (window.scrollY > 50) {
      siteHeader.classList.add('scrolled');
    } else {
      siteHeader.classList.remove('scrolled');
    }
  });

  // --- Dynamic Product Rendering (STRICT REAL SHOPIFY PRODUCTS ONLY) ---
  function renderProducts(categoryFilter = 'all') {
    const gridEl = document.getElementById('auraProductsGrid') || document.getElementById('productsGrid');
    if (!gridEl) return;
    gridEl.innerHTML = '';
    
    // Extract real products list from Shopify environment
    let realProductsList = [];
    if (window.auraShopifyProducts && Array.isArray(window.auraShopifyProducts) && window.auraShopifyProducts.length > 0) {
      realProductsList = window.auraShopifyProducts;
    } else if (Object.keys(shopifyProductsMap).length > 0) {
      realProductsList = Object.values(shopifyProductsMap);
    }

    if (realProductsList.length > 0) {
      const seenHandles = new Set();
      let renderedCount = 0;

      realProductsList.forEach((sp, idx) => {
        if (!sp || !sp.title) return;
        const handle = sp.handle || sp.title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        if (seenHandles.has(handle)) return;
        seenHandles.add(handle);

        // Category filter if active
        const spType = (sp.product_type || sp.category || sp.type || '').toLowerCase();
        if (categoryFilter !== 'all' && spType && !spType.includes(categoryFilter.toLowerCase())) {
          return;
        }

        renderedCount++;
        const card = document.createElement('div');
        card.classList.add('product-card');
        card.setAttribute('data-product-id', sp.id);

        const priceVal = parseFloat(sp.price || (sp.variants && sp.variants[0] ? sp.variants[0].price : 0)) || 0;
        const comparePriceVal = parseFloat(sp.compare_at_price || sp.originalPrice || (sp.variants && sp.variants[0] ? sp.variants[0].compare_at_price : 0)) || 0;

        const displayPriceFormatted = sp.price_formatted || `$${priceVal.toFixed(2)}`;
        const displayCompareFormatted = sp.compare_at_price_formatted || (comparePriceVal > 0 ? `$${comparePriceVal.toFixed(2)}` : '');

        const spTags = (sp.tags || sp.tags_list || []).toString().toLowerCase();
        let badgeHtml = '';
        if (comparePriceVal > priceVal) {
          badgeHtml = `<span class="badge badge-sale">Sale ${Math.round((1 - priceVal/comparePriceVal)*100)}%</span>`;
        } else if (spTags.includes('hot') || idx % 3 === 0) {
          badgeHtml = `<span class="badge badge-new">HOT</span>`;
        }

        const originalPriceHtml = comparePriceVal > priceVal
          ? `<span class="price-original">${displayCompareFormatted}</span>`
          : '';

        let mainImg = '';
        if (sp.featured_image) {
          mainImg = typeof sp.featured_image === 'string' ? sp.featured_image : (sp.featured_image.src || sp.featured_image);
        } else if (sp.images && sp.images.length > 0) {
          mainImg = typeof sp.images[0] === 'string' ? sp.images[0] : (sp.images[0].src || sp.images[0]);
        }

        let hoverImg = mainImg;
        if (sp.images && sp.images.length > 1) {
          hoverImg = typeof sp.images[1] === 'string' ? sp.images[1] : (sp.images[1].src || sp.images[1]);
        }

        const productUrl = sp.url || `/products/${handle}`;
        const isWishlisted = wishlist.includes(sp.id);

        card.innerHTML = `
          <div class="product-image-box">
            <a href="${productUrl}" class="product-card-image-link" style="display: block; width: 100%;">
              <div class="product-badges">${badgeHtml}</div>
              <img src="${mainImg}" alt="${sp.title}" class="product-image" loading="lazy">
              <img src="${hoverImg}" alt="${sp.title} Details" class="product-image-hover" loading="lazy">
            </a>
            <button class="btn-wishlist-card ${isWishlisted ? 'active' : ''}" data-product-id="${sp.id}" title="Add to Wishlist">
              <i class="fa-${isWishlisted ? 'solid' : 'regular'} fa-heart"></i>
            </button>
            <button type="button" class="quick-view-btn btn-quick-view-overlay" data-product-id="${sp.id}" title="Quick View"><i class="fa-solid fa-eye"></i> Quick View</button>
          </div>
          <div class="product-info">
            <span class="product-vendor">${sp.vendor || ''}</span>
            <h3 class="product-title"><a href="${productUrl}">${sp.title}</a></h3>
            <div class="product-price-box">
              <span class="price-current">${displayPriceFormatted}</span>
              ${originalPriceHtml}
            </div>
          </div>
        `;

        const qvBtn = card.querySelector('.quick-view-btn');
        if (qvBtn) {
          qvBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (typeof openQuickView === 'function') openQuickView(sp.id);
            else if (typeof window.openQuickView === 'function') window.openQuickView(sp.id);
          });
        }

        card.querySelector('.btn-wishlist-card').addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleWishlist(sp.id);
        });

        gridEl.appendChild(card);
      });

      if (renderedCount > 0) return;
    }

    // Fallback: If no real products match or exist in store
    productsGrid.innerHTML = `
      <p style="grid-column: 1 / -1; text-align: center; color: var(--color-text-muted); padding: 40px 0; font-size: 1.1rem;">
        No products found in store. Please add products at admin.shopify.com/products
      </p>
    `;
  }

  // Initial render
  renderProducts();

  // Global Event Delegation for Quick View & Round Shopping Cart Icon Button on Product Cards
  document.addEventListener('click', function(e) {
    const qvBtn = e.target.closest('.quick-view-btn, .btn-quick-view-overlay');
    if (qvBtn) {
      e.preventDefault();
      e.stopPropagation();
      const card = qvBtn.closest('.card-wrapper, .product-card, .card');
      const pid = qvBtn.getAttribute('data-product-id') || (card ? card.getAttribute('data-product-id') : null);
      if (typeof window.openQuickView === 'function') {
        window.openQuickView(pid);
      }
      return;
    }

    const cartBtn = e.target.closest('.btn-card-quick-cart');
    if (cartBtn) {
      e.preventDefault();
      e.stopPropagation();

      const card = cartBtn.closest('.card-wrapper, .product-card, .card');
      let variantId = cartBtn.getAttribute('data-variant-id') || cartBtn.getAttribute('data-product-id');
      if (!variantId && card) {
        const variantInput = card.querySelector('input[name="id"], [data-variant-id]');
        if (variantInput) variantId = variantInput.value || variantInput.getAttribute('data-variant-id');
      }

      const origHtml = cartBtn.innerHTML;
      cartBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i>';

      if (variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId) || variantId, quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          cartBtn.innerHTML = origHtml;
          if (typeof window.refreshAuraCartData === 'function') window.refreshAuraCartData();
          if (typeof window.openAuraCart === 'function') window.openAuraCart();
        })
        .catch(function() {
          cartBtn.innerHTML = origHtml;
          if (typeof window.refreshAuraCartData === 'function') window.refreshAuraCartData();
          if (typeof window.openAuraCart === 'function') window.openAuraCart();
        });
      } else {
        cartBtn.innerHTML = origHtml;
        const link = card ? card.querySelector('a[href*="/products/"]') : null;
        if (link) window.location.href = link.href;
      }
    }
  }, true);

  // Inject round cart icon button ONLY on Catalog/Collection pages (/collections/*) & remove old gold pills
  function injectRoundCartIconOnDawnCards() {
    const isCatalog = window.location.pathname.includes('/collections');
    if (!isCatalog) {
      // Clean up any injected cart buttons on Homepage or PDP to keep original design
      document.querySelectorAll('.btn-card-quick-cart').forEach(function(el) {
        el.remove();
      });
      return;
    }

    const goldPills = document.querySelectorAll('quick-add-component, .quick-add, .quick-add__submit, .quick-add-submit');
    goldPills.forEach(function(el) {
      if (el && el.parentNode) {
        el.remove();
      }
    });

    const cards = document.querySelectorAll('.card-wrapper, .product-card, .card');
    cards.forEach(function(card) {
      if (!card.querySelector('.btn-card-quick-cart')) {
        const imgBox = card.querySelector('.card__media, .product-image-box, .media');
        if (imgBox) {
          imgBox.style.position = 'relative';
          const variantInput = card.querySelector('input[name="id"], [data-variant-id]');
          const vid = variantInput ? (variantInput.value || variantInput.getAttribute('data-variant-id')) : '';
          
          const iconBtn = document.createElement('button');
          iconBtn.type = 'button';
          iconBtn.className = 'btn-card-quick-cart';
          iconBtn.setAttribute('data-variant-id', vid);
          iconBtn.title = 'Add to Bag';
          iconBtn.innerHTML = '<i class="fa-solid fa-bag-shopping"></i> <span>Add</span>';
          imgBox.appendChild(iconBtn);
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', injectRoundCartIconOnDawnCards);
  setInterval(injectRoundCartIconOnDawnCards, 500);




  // --- Dynamic Random HOT Product Hero Slider Engine ---
  function initDynamicHeroSlider() {
    const heroSliderElem = document.getElementById('heroSlider');
    if (!heroSliderElem) return;

    let availableProducts = window.auraShopifyProducts || window.auraRealShopifyList || [];
    if (!availableProducts || availableProducts.length === 0) return;

    // Filter products (preferably HOT or all real products)
    let hotProducts = availableProducts.filter(p => {
      if (!p) return false;
      const compare = parseFloat(p.compare_at_price || 0);
      const price = parseFloat(p.price || 0);
      const tags = (p.tags || p.product_type || p.vendor || '').toString().toLowerCase();
      return tags.includes('hot') || compare <= price || compare === 0 || isNaN(compare);
    });

    if (hotProducts.length === 0) {
      hotProducts = availableProducts;
    }

    // Random shuffle using Fisher-Yates
    const shuffled = [...hotProducts].sort(() => 0.5 - Math.random());
    const selectedProds = shuffled.slice(0, 5);

    if (selectedProds.length === 0) return;

    let slidesHtml = '';
    let dotsHtml = '';

    selectedProds.forEach((sp, idx) => {
      const handle = sp.handle || (sp.title ? sp.title.toLowerCase().replace(/[^a-z0-9]+/g, '-') : '');
      const productUrl = sp.url || `/products/${handle}`;

      let bgImg = '';
      if (sp.featured_image) {
        bgImg = typeof sp.featured_image === 'string' ? sp.featured_image : (sp.featured_image.src || sp.featured_image);
      } else if (sp.images && sp.images.length > 0) {
        bgImg = typeof sp.images[0] === 'string' ? sp.images[0] : (sp.images[0].src || sp.images[0]);
      }

      const vendor = sp.vendor || '';
      const title = sp.title || 'AURA 3D Graphic Apparel';
      const desc = sp.description ? sp.description.replace(/<[^>]*>?/gm, '').split(' ').slice(0, 25).join(' ') : 'Uncompromising high-definition all-over-print graphic tee.';

      slidesHtml += `
        <div class="slide ${idx === 0 ? 'active' : ''}" data-slide-index="${idx}">
          ${bgImg ? `<img src="${bgImg}" alt="${title}" class="slide-bg">` : `<div class="slide-bg-gradient" style="position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(135deg, #08080a 0%, #1a1a24 50%, #08080a 100%);"></div>`}
          <div class="container" style="position:relative;z-index:2;">
            <div class="slide-content">
              <span class="slide-tagline"><span style="background:linear-gradient(135deg,#d4af37,#b8860b);color:#000;padding:3px 10px;border-radius:4px;font-weight:800;font-size:11px;margin-right:8px;letter-spacing:1px;">HOT</span> 3D PRINT ARTWEAR • ${vendor}</span>
              <h1 class="slide-title">${title}</h1>
              <p class="slide-desc">${desc}</p>
              <div class="slide-actions">
                <a href="${productUrl}" class="btn btn-primary">BUY NOW</a>
              </div>
            </div>
          </div>
        </div>
      `;

      dotsHtml += `<span class="slider-dot ${idx === 0 ? 'active' : ''}" data-slide="${idx}"></span>`;
    });

    let navHtml = '';
    if (selectedProds.length > 1) {
      navHtml = `
        <div class="slider-nav" id="sliderNav">${dotsHtml}</div>
        <button class="slider-arrow slider-arrow-prev" id="sliderPrevBtn" aria-label="Previous Slide"><i class="fa-solid fa-chevron-left"></i></button>
        <button class="slider-arrow slider-arrow-next" id="sliderNextBtn" aria-label="Next Slide"><i class="fa-solid fa-chevron-right"></i></button>
      `;
    }

    heroSliderElem.innerHTML = slidesHtml + navHtml;
    activeSlide = 0;

    // Rebind listeners
    const newPrev = document.getElementById('sliderPrevBtn');
    const newNext = document.getElementById('sliderNextBtn');
    if (newPrev && newNext) {
      newPrev.addEventListener('click', () => showSlide(activeSlide - 1));
      newNext.addEventListener('click', () => showSlide(activeSlide + 1));
    }

    document.querySelectorAll('.slider-dot').forEach(dot => {
      dot.addEventListener('click', (e) => {
        const targetIndex = parseInt(e.target.getAttribute('data-slide'));
        showSlide(targetIndex);
      });
    });
  }

  // Initial call
  initDynamicHeroSlider();

  // --- Hero Slider Logic ---
  function showSlide(index) {
    const currentSlides = document.querySelectorAll('.slide');
    const currentDots = document.querySelectorAll('.slider-dot');
    if (!currentSlides || currentSlides.length <= 1) return;

    if (currentSlides[activeSlide]) currentSlides[activeSlide].classList.remove('active');
    if (currentDots[activeSlide]) currentDots[activeSlide].classList.remove('active');
    
    activeSlide = (index + currentSlides.length) % currentSlides.length;
    
    if (currentSlides[activeSlide]) currentSlides[activeSlide].classList.add('active');
    if (currentDots[activeSlide]) currentDots[activeSlide].classList.add('active');
  }

  if (sliderNextBtn && sliderPrevBtn) {
    sliderNextBtn.addEventListener('click', () => showSlide(activeSlide + 1));
    sliderPrevBtn.addEventListener('click', () => showSlide(activeSlide - 1));
  }

  sliderDots.forEach(dot => {
    dot.addEventListener('click', (e) => {
      const targetIndex = parseInt(e.target.getAttribute('data-slide'));
      showSlide(targetIndex);
    });
  });

  // Autoplay Slider
  let sliderInterval = setInterval(() => {
    showSlide(activeSlide + 1);
  }, 6000);

  const heroSlider = document.getElementById('heroSlider');
  if (heroSlider) {
    heroSlider.addEventListener('mouseenter', () => clearInterval(sliderInterval));
    heroSlider.addEventListener('mouseleave', () => {
      sliderInterval = setInterval(() => {
        showSlide(activeSlide + 1);
      }, 6000);
    });
  }

  // --- Tab Switcher Logic ---
  tabBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      // Remove active states
      tabBtns.forEach(b => b.classList.remove('active'));
      
      // Add active state to clicked
      e.target.classList.add('active');
      const targetCategory = e.target.getAttribute('data-category');
      
      // Dynamic render based on clicked tab category
      renderProducts(targetCategory);
    });
  });  // --- Cart Drawer Toggles ---
  function openCart() {
    saveScrollPosition();
    cartOverlay.classList.add('open');
    cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';

    const chkBtn = document.getElementById('checkoutBtn');
    if (chkBtn) {
      chkBtn.setAttribute('onclick', 'handleShopifyCheckout(event)');
      chkBtn.onclick = handleCheckoutRedirect;
    }
  }

  function closeCart() {
    cartOverlay.classList.remove('open');
    cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
    restoreScrollPosition();
  }

  if (cartToggleBtn) cartToggleBtn.addEventListener('click', openCart);
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (continueShoppingBtn) continueShoppingBtn.addEventListener('click', (e) => {
    e.preventDefault();
    closeCart();
  });

  // --- Universal Shopify Cart Checkout Engine (Rate-Limit Protected) ---
  let isSyncingCheckout = false;
  let checkoutSafetyTimer = null;

  function resetCheckoutButtons() {
    isSyncingCheckout = false;
    if (checkoutSafetyTimer) {
      clearTimeout(checkoutSafetyTimer);
      checkoutSafetyTimer = null;
    }
    const checkoutBtns = document.querySelectorAll('#checkoutBtn, .btn-checkout-yellow, .btn-checkout, [name="checkout"], .shop-pay-btn, .g-pay-btn');
    checkoutBtns.forEach(btn => {
      btn.disabled = false;
      btn.removeAttribute('disabled');
      btn.style.opacity = '1';
      if (btn.classList.contains('shop-pay-btn')) {
        btn.innerHTML = '<span class="buy-with">Buy with </span><span class="shop-logo">shop</span>';
      } else if (btn.classList.contains('g-pay-btn')) {
        btn.innerHTML = '<i class="fa-brands fa-google-pay"></i> Pay';
      } else {
        btn.innerHTML = 'CHECKOUT';
      }
    });
  }

  window.resetCheckoutButtons = resetCheckoutButtons;
  window.addEventListener('pageshow', resetCheckoutButtons);

  async function handleCheckoutRedirect(e) {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
      e.stopPropagation();
    }

    if (isSyncingCheckout) {
      console.log('[Shopify Cart Engine] Checkout sync already in progress, ignoring duplicate click.');
      return false;
    }

    isSyncingCheckout = true;

    const btnTarget = (e && e.target) ? e.target.closest('#checkoutBtn, .btn-checkout-yellow, .btn-checkout, [name="checkout"], .shop-pay-btn, .g-pay-btn') : null;
    if (btnTarget) {
      btnTarget.disabled = true;
      btnTarget.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> REDIRECTING...';
    }

    // Safety timeout: auto reset checkout buttons if redirect doesn't complete within 5s
    if (checkoutSafetyTimer) clearTimeout(checkoutSafetyTimer);
    checkoutSafetyTimer = setTimeout(resetCheckoutButtons, 5000);

    console.log("[Shopify Cart Engine] Synchronizing cart to Shopify server before checkout...");

    const isLocal = window.location.protocol.startsWith('file') || 
                    window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' ||
                    window.location.port === '8080' || 
                    window.location.port === '3000' ||
                    window.location.port === '5500' ||
                    !window.location.hostname.includes('.');

    if (isLocal) {
      if (typeof closeCart === 'function') closeCart();
      if (typeof openCheckoutModal === 'function') {
        openCheckoutModal();
      } else if (typeof openCheckout === 'function') {
        openCheckout(e);
      }
      if (btnTarget) {
        btnTarget.disabled = false;
        btnTarget.innerHTML = 'CHECKOUT';
      }
      isSyncingCheckout = false;
      return false;
    }
    if ((!cart || cart.length === 0) && !window.location.protocol.startsWith('file')) {
      try {
        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) {
          const serverCart = await cartRes.json();
          if (serverCart && serverCart.items && serverCart.items.length > 0) {
            cart = serverCart.items.map(item => ({
              id: item.product_id,
              variantId: item.variant_id,
              title: item.product_title || item.title,
              price: item.price / 100,
              quantity: item.quantity,
              image: item.image,
              size: item.variant_title || 'Default',
              color: ''
            }));
          }
        }
      } catch(err) {
        console.warn('[Shopify Cart Engine] Fetch server cart fallback:', err);
      }
    }

    // Live Shopify Storefront Cart Synchronization via /cart/update.js (Exact Quantity Lock)
    try {
      if (cart && cart.length > 0) {
        const updatesMap = {};
        
        cart.forEach(item => {
          let vId = item.variantId;
          
          if (!vId) {
            const realProds = window.auraShopifyProducts || [];
            const foundProd = realProds.find(p => p.id == item.id || p.handle == item.id || p.title === item.title);
            if (foundProd && foundProd.variants && foundProd.variants.length > 0) {
              const matchedVar = foundProd.variants.find(v => {
                const vt = (v.title || '').toLowerCase();
                const sz = (item.size || '').toLowerCase();
                const clr = (item.color || '').toLowerCase();
                return (sz && vt.includes(sz)) || (clr && vt.includes(clr));
              }) || foundProd.variants[0];
              
              vId = matchedVar.id;
            }
          }

          if (vId) {
            const numericId = parseInt(vId, 10) || vId;
            updatesMap[numericId] = parseInt(item.quantity, 10) || 1;
          }
        });

        // 1. Clear server cart first to eliminate duplicate additions from previous clicks
        await fetch('/cart/clear.js', { 
          method: 'POST', 
          headers: { 'Content-Type': 'application/json' } 
        }).catch(() => {});

        // 2. Set EXACT quantities using Shopify's official /cart/update.js API
        const updateRes = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updatesMap })
        });

        if (updateRes.ok) {
          console.log('[Shopify Cart Engine] Cart EXACT quantities locked successfully:', updatesMap);
        }
      } else {
        // If cart is empty, ensure server cart is cleared
        await fetch('/cart/clear.js', { method: 'POST' }).catch(() => {});
      }
    } catch(err) {
      console.warn('[Shopify Cart Engine] Sync update fallback:', err);
    } finally {
      isSyncingCheckout = false;
    }

    // Direct seamlessly to official Shopify Checkout
    window.location.href = '/checkout';
    return false;
  }

  // Export functions to global window object for inline HTML onclick attributes
  window.handleShopifyCheckout = handleCheckoutRedirect;
  window.handleCheckoutRedirect = handleCheckoutRedirect;
  window.openCheckout = handleCheckoutRedirect;

  // Triple-layer Capture Phase Delegate click for all checkout buttons
  document.addEventListener('click', function(e) {
    const targetBtn = e.target.closest('#checkoutBtn, .btn-checkout-yellow, .btn-checkout, [name="checkout"], .shop-pay-btn, .g-pay-btn');
    if (targetBtn) {
      handleCheckoutRedirect(e);
    }
  }, true);

  // --- Cart Core Logic ---
  
  // --- Cart Reservation Timer Logic ---
  let cartTimerInterval = null;
  function startCartTimer() {
    if (cartTimerInterval) clearInterval(cartTimerInterval);
    let duration = 300; // 5 minutes in seconds
    const timerDisplay = document.getElementById('cartTimer');
    
    function updateTimer() {
      const minutes = Math.floor(duration / 60);
      const seconds = duration % 60;
      if (timerDisplay) {
        timerDisplay.textContent = `${minutes} m ${seconds < 10 ? '0' : ''}${seconds} s!`;
      }
      if (duration <= 0) {
        clearInterval(cartTimerInterval);
      } else {
        duration--;
      }
    }
    updateTimer();
    cartTimerInterval = setInterval(updateTimer, 1000);
  }

  function updateCartUI() {
    const totalItems = cart.reduce((total, item) => total + item.quantity, 0);
    
    cartCountBadges.forEach(badge => {
      if (badge) badge.textContent = totalItems;
    });

    if (totalItems === 0) {
      emptyCartState.style.display = 'flex';
      cartItemsList.style.display = 'none';
      cartDrawerFooter.style.display = 'none';
    } else {
      emptyCartState.style.display = 'none';
      cartItemsList.style.display = 'flex';
      cartDrawerFooter.style.display = 'block';

      cartItemsList.innerHTML = '';
      let subtotal = 0;

        // --- Timer & Shipping Progress Update ---
        const promoBanner = document.getElementById('cartPromoBanner');
        if (promoBanner) {
          if (totalItems > 0) {
            promoBanner.style.display = 'block';
            startCartTimer();
          } else {
            promoBanner.style.display = 'none';
            if (cartTimerInterval) clearInterval(cartTimerInterval);
          }
        }

        // Free shipping calculation
        const shippingThreshold = 75.00;
        const progressText = document.getElementById('shippingProgressText');
        const progressFill = document.getElementById('shippingProgressFill');
        
        if (progressText && progressFill) {
          if (subtotal >= shippingThreshold) {
            progressText.innerHTML = "🎉 You have unlocked <strong>FREE Shipping!</strong>";
            progressFill.style.width = "100%";
          } else {
            const diff = (shippingThreshold - subtotal).toFixed(2);
            progressText.innerHTML = `You're exactly <strong>$${diff}</strong> away from unlocking <strong>FREE Shipping!</strong>`;
            const percentage = Math.min((subtotal / shippingThreshold) * 100, 100);
            progressFill.style.width = `${percentage}%`;
          }
        }

      cart.forEach((item, index) => {
        subtotal += item.price * item.quantity;
        const itemEl = document.createElement('div');
        itemEl.classList.add('cart-item');
        itemEl.innerHTML = `
          <img src="${item.image}" alt="${item.title}" class="cart-item-image">
          <div class="cart-item-info">
            <h4 class="cart-item-title">${item.title}</h4>
            <div class="cart-item-variant">${item.color} / ${item.size}</div>
            <div class="cart-item-price">$${(item.price * item.quantity).toFixed(2)}</div>
            <div class="cart-item-qty">
              <span class="qty-btn minus-qty" data-index="${index}">-</span>
              <span class="qty-val">${item.quantity}</span>
              <span class="qty-btn plus-qty" data-index="${index}">+</span>
            </div>
          </div>
          <button class="cart-item-remove remove-item" data-index="${index}" aria-label="Remove item">
            <i class="fa-regular fa-trash-can"></i>
          </button>
        `;
        cartItemsList.appendChild(itemEl);
      });

      if (cartSubtotalPrice) cartSubtotalPrice.textContent = `$${subtotal.toFixed(2)}`;

      document.querySelectorAll('.minus-qty').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const index = parseInt(e.target.getAttribute('data-index'));
          changeQuantity(index, -1);
        });
      });

      document.querySelectorAll('.plus-qty').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const index = parseInt(e.target.getAttribute('data-index'));
          changeQuantity(index, 1);
        });
      });

      document.querySelectorAll('.remove-item').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const btnTarget = e.target.closest('.remove-item');
          const index = parseInt(btnTarget.getAttribute('data-index'));
          removeFromCart(index);
        });
      });
    }
  }

  function addToCart(productId, qtyToAdd) {
    let product = null;
    if (typeof productId === 'object' && productId !== null) {
      product = productId;
    } else if (productsData && productsData[productId]) {
      product = productsData[productId];
    } else if (currentProductInModal) {
      product = currentProductInModal;
    } else {
      const realProds = window.auraShopifyProducts || [];
      product = realProds.find(p => p.id == productId || p.handle == productId);
    }

    if (!product) return;

    const realProduct = product.realProduct || shopifyProductsMap[(product.title || '').toLowerCase().trim()];
    const displayTitle = (realProduct && realProduct.title) ? realProduct.title : (product.systemTitle || product.title);
    const displayPrice = (realProduct && realProduct.price) 
      ? parseFloat(realProduct.price) 
      : (realProduct && realProduct.variants && realProduct.variants[0] ? parseFloat(realProduct.variants[0].price) : (product.price || 0));
    let displayImage = product.image;
    if (realProduct && realProduct.featured_image) {
      displayImage = typeof realProduct.featured_image === 'string' ? realProduct.featured_image : (realProduct.featured_image.src || realProduct.featured_image);
    }

    const existingItem = cart.find(item => 
      (item.id === product.id || item.title === displayTitle) && 
      item.size === selectedSize && 
      item.color === selectedColor
    );
    
    if (existingItem) {
      existingItem.quantity += qtyToAdd;
      existingItem.title = displayTitle;
      existingItem.price = parseFloat(displayPrice);
    } else {
      cart.push({
        id: product.id,
        title: displayTitle,
        price: parseFloat(displayPrice),
        image: displayImage || '',
        quantity: qtyToAdd,
        size: selectedSize || "M",
        color: selectedColor || "Navy Blue"
      });
    }

    saveMockCart();
    updateCartUI();
    closeQuickView();

    // Post to Shopify Server Ajax API /cart/add.js
    if (realProduct && realProduct.variants && realProduct.variants[0]) {
      const vId = realProduct.variants[0].id;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vId, quantity: qtyToAdd })
      }).catch(() => {});
    }

    if (typeof window.refreshAuraCartData === 'function') {
      window.refreshAuraCartData();
    }
    if (typeof window.openAuraCart === 'function') {
      window.openAuraCart();
    } else {
      openCart();
    }
  }

  // Make functions globally accessible for inline dynamic HTML click handlers
  window.openCart = openCart;
  window.closeCart = closeCart;
  window.updateCartUI = updateCartUI;
  window.addToCart = addToCart;

  window.openQuickView = function(productId) {
    let product = null;
    if (typeof productId === 'object' && productId !== null) {
      product = productId;
    } else if (productsData && productsData[productId]) {
      product = productsData[productId];
    } else {
      const realProds = window.auraShopifyProducts || [];
      const found = realProds.find(p => p.id == productId || p.handle == productId);
      if (found) {
        const priceVal = parseFloat(found.price || 0) || 0;
        const compareVal = parseFloat(found.compare_at_price || 0) || 0;
        let mainImg = found.featured_image;
        if (typeof mainImg !== 'string') mainImg = mainImg ? (mainImg.src || mainImg) : '';
        product = {
          id: found.id,
          title: found.title,
          vendor: found.vendor || '',
          price: priceVal,
          originalPrice: compareVal > priceVal ? compareVal : null,
          image: mainImg || (found.images && found.images[0] ? (typeof found.images[0] === 'string' ? found.images[0] : found.images[0].src) : ''),
          reviewsCount: 88,
          rating: 5,
          desc: found.description ? found.description.replace(/<[^>]*>?/gm, '') : 'Uncompromising high-definition 3D all-over-print graphic apparel crafted with luxury microfiber blend.'
        };
      }
    }

    if (!product) return;

    currentProductInModal = product;
    window.currentProductInModal = product;
    modalQty = 1;

    const realProduct = product.realProduct || shopifyProductsMap[(product.title || '').toLowerCase().trim()];
    const displayTitle = (realProduct && realProduct.title) ? realProduct.title : (product.systemTitle || product.title);
    const displayPrice = (realProduct && realProduct.price) 
      ? parseFloat(realProduct.price) 
      : (realProduct && realProduct.variants && realProduct.variants[0] ? parseFloat(realProduct.variants[0].price) : (product.price || 0));
    let displayImage = product.image;
    if (realProduct && realProduct.featured_image) {
      displayImage = typeof realProduct.featured_image === 'string' ? realProduct.featured_image : (realProduct.featured_image.src || realProduct.featured_image);
    }
    if (displayImage && typeof displayImage === 'string') {
      displayImage = displayImage.replace(/_(small|compact|medium|100x100|150x150|200x200)\./, '_800x.');
    }

    if (modalProductImage) {
      modalProductImage.src = displayImage || '';
      modalProductImage.alt = displayTitle || '';
    }
    if (modalProductVendor) modalProductVendor.textContent = product.vendor || '';
    if (modalProductTitle) modalProductTitle.textContent = displayTitle || '';
    if (modalProductRatingReviews) modalProductRatingReviews.textContent = `(${product.reviewsCount || 88} reviews)`;
    if (modalProductPriceCurrent) modalProductPriceCurrent.textContent = `$${parseFloat(displayPrice || 0).toFixed(2)}`;
    
    if (modalProductPriceOriginal) {
      const compPrice = product.originalPrice || (realProduct && realProduct.compare_at_price ? parseFloat(realProduct.compare_at_price) : 45.00);
      if (compPrice && parseFloat(compPrice) > parseFloat(displayPrice)) {
        modalProductPriceOriginal.textContent = `$${parseFloat(compPrice).toFixed(2)}`;
        modalProductPriceOriginal.style.display = 'inline-block';
        modalProductPriceOriginal.style.textDecoration = 'line-through';
        modalProductPriceOriginal.style.color = '#a1a1aa';
        modalProductPriceOriginal.style.marginLeft = '8px';
      } else {
        modalProductPriceOriginal.style.display = 'none';
      }
    }

    if (modalProductDesc) {
      modalProductDesc.textContent = product.desc || 'Uncompromising high-definition 3D all-over-print graphic tee.';
      modalProductDesc.style.color = '#ffffff';
      modalProductDesc.style.webkitTextFillColor = '#ffffff';
      modalProductDesc.style.opacity = '1';
    }
    if (modalQtyVal) modalQtyVal.textContent = modalQty;

    // --- Dynamic Options (Sizes & Colors) Rendering ---
    const colorSwatchesContainer = document.getElementById('modalColorSwatches');
    const sizeSwatchesContainer = document.getElementById('modalSizeSwatches');
    const selectedColorLabel = document.getElementById('modalSelectedColor');
    const selectedSizeLabel = document.getElementById('modalSelectedSize');

    if (colorSwatchesContainer) {
      colorSwatchesContainer.innerHTML = '';
      const colors = [
        { name: "Navy Blue", value: "#1e293b" },
        { name: "Charcoal", value: "#334155" },
        { name: "Heather Gray", value: "#64748b" }
      ];
      selectedColor = colors[0].name;
      if (selectedColorLabel) selectedColorLabel.textContent = selectedColor;

      colors.forEach((color, idx) => {
        const swatch = document.createElement('div');
        swatch.classList.add('color-swatch');
        if (idx === 0) swatch.classList.add('active');
        swatch.style.backgroundColor = color.value;
        swatch.title = color.name;
        swatch.addEventListener('click', () => {
          colorSwatchesContainer.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
          swatch.classList.add('active');
          selectedColor = color.name;
          if (selectedColorLabel) selectedColorLabel.textContent = selectedColor;
        });
        colorSwatchesContainer.appendChild(swatch);
      });
    }

    if (sizeSwatchesContainer) {
      sizeSwatchesContainer.innerHTML = '';
      const sizes = ["S", "M", "L", "XL", "2XL", "3XL"];
      selectedSize = "M"; // Default to Medium
      if (selectedSizeLabel) selectedSizeLabel.textContent = selectedSize;

      sizes.forEach(size => {
        const swatch = document.createElement('div');
        swatch.classList.add('size-swatch');
        if (size === "M") swatch.classList.add('active');
        swatch.textContent = size;
        swatch.addEventListener('click', () => {
          sizeSwatchesContainer.querySelectorAll('.size-swatch').forEach(s => s.classList.remove('active'));
          swatch.classList.add('active');
          selectedSize = size;
          if (selectedSizeLabel) selectedSizeLabel.textContent = selectedSize;
        });
        sizeSwatchesContainer.appendChild(swatch);
      });
    }

    // --- Wishlist Management System ---
    const modalWishlistBtn = document.getElementById('modalWishlistBtn');
    if (modalWishlistBtn) {
      modalWishlistBtn.onclick = function(e) {
        if (e && e.stopPropagation) e.stopPropagation();
        if (window.currentProductInModal) {
          window.toggleWishlist(window.currentProductInModal.id, window.currentProductInModal);
        }
      };
    }

    if (typeof window.updateWishlistUI === 'function') {
      window.updateWishlistUI();
    }

    saveScrollPosition();
    quickViewOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.closeQuickView = function() {
    const qvOverlay = document.getElementById('quickViewOverlay');
    if (qvOverlay) {
      qvOverlay.classList.remove('open');
    }
    document.body.style.overflow = '';
    if (typeof restoreScrollPosition === 'function') {
      restoreScrollPosition();
    }
  };

  document.addEventListener('click', function(e) {
    const modalCloseBtn = e.target.closest('#modalCloseBtn, .modal-close');
    if (modalCloseBtn) {
      e.preventDefault();
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
      window.closeQuickView();
      return;
    }
    if (e.target && e.target.id === 'quickViewOverlay') {
      e.preventDefault();
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
      window.closeQuickView();
      return;
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      window.closeQuickView();
    }
  });

    // --- Global Wishlist Deduplication Engine ---
  function dedupeWishlist(list) {
    if (!Array.isArray(list)) return [];
    const uniqueList = [];
    list.forEach(item => {
      if (!item) return;
      const itemTitle = (typeof item === 'object' && item !== null) ? String(item.title || '').toLowerCase().trim() : '';
      const itemHandle = (typeof item === 'object' && item !== null) ? String(item.handle || item.id || '').toLowerCase() : String(item).toLowerCase();
      const itemId = (typeof item === 'object' && item !== null) ? String(item.id || item.handle || '').toLowerCase() : String(item).toLowerCase();

      const exists = uniqueList.some(u => {
        const uTitle = (typeof u === 'object' && u !== null) ? String(u.title || '').toLowerCase().trim() : '';
        const uHandle = (typeof u === 'object' && u !== null) ? String(u.handle || u.id || '').toLowerCase() : String(u).toLowerCase();
        const uId = (typeof u === 'object' && u !== null) ? String(u.id || u.handle || '').toLowerCase() : String(u).toLowerCase();

        if (itemTitle && uTitle && itemTitle === uTitle) return true;
        if (itemHandle && (itemHandle === uHandle || itemHandle === uId)) return true;
        if (itemId && (itemId === uHandle || itemId === uId)) return true;
        return false;
      });

      if (!exists) {
        uniqueList.push(item);
      }
    });
    return uniqueList;
  }

  window.getWishlist = function() {
    try {
      const raw = localStorage.getItem('aura_wishlist') || localStorage.getItem('auraWishlist') || localStorage.getItem('inklooma_wishlist') || '[]';
      const parsed = JSON.parse(raw);
      return dedupeWishlist(parsed);
    } catch (e) {
      return [];
    }
  };

  window.saveWishlist = function(list) {
    try {
      const cleanList = dedupeWishlist(list);
      localStorage.setItem('aura_wishlist', JSON.stringify(cleanList));
      localStorage.setItem('auraWishlist', JSON.stringify(cleanList));
      localStorage.setItem('inklooma_wishlist', JSON.stringify(cleanList));
    } catch (e) {}
    window.updateWishlistUI();
  };

  window.isProductInWishlist = function(target) {
    if (!target) return false;
    const list = window.getWishlist();
    if (!Array.isArray(list) || list.length === 0) return false;

    let targetId = '';
    let targetHandle = '';
    let targetTitle = '';

    if (typeof target === 'object' && target !== null) {
      targetId = String(target.id || '').toLowerCase().trim();
      targetHandle = String(target.handle || target.id || '').toLowerCase().trim();
      targetTitle = String(target.title || target.systemTitle || '').toLowerCase().trim();
    } else {
      const str = String(target || '').toLowerCase().trim();
      targetId = str;
      targetHandle = str;
      targetTitle = str;
    }

    const slugTarget = targetTitle ? targetTitle.replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') : targetHandle;

    return list.some(item => {
      if (!item) return false;
      let itemH = '';
      let itemI = '';
      let itemT = '';

      if (typeof item === 'object' && item !== null) {
        itemH = String(item.handle || item.id || '').toLowerCase().trim();
        itemI = String(item.id || item.handle || '').toLowerCase().trim();
        itemT = String(item.title || '').toLowerCase().trim();
      } else {
        const s = String(item).toLowerCase().trim();
        itemH = s;
        itemI = s;
        itemT = s;
      }

      if (targetTitle && itemT && targetTitle === itemT) return true;
      if (targetId && (targetId === itemI || targetId === itemH)) return true;
      if (targetHandle && (targetHandle === itemI || targetHandle === itemH)) return true;

      const slugItem = itemT ? itemT.replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') : itemH;
      if (slugTarget && slugItem && slugTarget === slugItem) return true;

      return false;
    });
  };

  window.toggleWishlist = function(productId, productObj = null) {
    let list = window.getWishlist();
    let prod = productObj || (typeof productId === 'object' ? productId : null);
    
    const inputVal = (typeof productId === 'object' && productId !== null) ? String(productId.handle || productId.id) : String(productId || '');
    
    if (!prod && window.currentProductInModal && (String(window.currentProductInModal.id) === inputVal || String(window.currentProductInModal.handle) === inputVal)) {
      prod = window.currentProductInModal;
    }
    if (!prod && window.auraShopifyProducts) {
      prod = window.auraShopifyProducts.find(p => String(p.id) === inputVal || String(p.handle) === inputVal || (p.title && p.title.toLowerCase().trim() === inputVal.toLowerCase().trim()));
    }
    if (!prod && typeof shopifyProductsMap !== 'undefined') {
      prod = shopifyProductsMap[inputVal];
    }

    const activeTarget = prod || productId;
    if (!activeTarget) return;

    const isCurrentlyWishlisted = window.isProductInWishlist(activeTarget);

    let wishlistData = {};
    try { wishlistData = JSON.parse(localStorage.getItem('aura_wishlist_data') || '{}'); } catch(e) {}

    if (isCurrentlyWishlisted) {
      // TOGGLE OFF: Remove item from wishlist
      list = list.filter(item => {
        if (!item) return false;
        let itemH = (typeof item === 'object' && item !== null) ? String(item.handle || item.id || '').toLowerCase().trim() : String(item).toLowerCase().trim();
        let itemI = (typeof item === 'object' && item !== null) ? String(item.id || item.handle || '').toLowerCase().trim() : String(item).toLowerCase().trim();
        let itemT = (typeof item === 'object' && item !== null) ? String(item.title || '').toLowerCase().trim() : '';

        const tH = prod ? String(prod.handle || prod.id || '').toLowerCase().trim() : inputVal.toLowerCase().trim();
        const tI = prod ? String(prod.id || prod.handle || '').toLowerCase().trim() : inputVal.toLowerCase().trim();
        const tT = prod ? String(prod.title || '').toLowerCase().trim() : '';

        if (tT && itemT && tT === itemT) return false;
        if (tH && (itemH === tH || itemI === tH)) return false;
        if (tI && (itemH === tI || itemI === tI)) return false;
        
        const slugT = tT.replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
        const slugItem = itemT.replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
        if (slugT && slugItem && slugT === slugItem) return false;

        return true;
      });
      if (prod) {
        delete wishlistData[String(prod.handle)];
        delete wishlistData[String(prod.id)];
      }
      delete wishlistData[inputVal];
    } else {
      // TOGGLE ON: Add item to wishlist
      let prodId = prod ? String(prod.id) : inputVal;
      let prodHandle = prod ? String(prod.handle || prod.id) : inputVal;
      let prodTitle = prod ? String(prod.title || prod.systemTitle || '') : inputVal.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
      let img = prod ? (prod.image || (prod.featured_image ? (typeof prod.featured_image === 'string' ? prod.featured_image : prod.featured_image.src) : '')) : '';
      if (img && typeof img === 'string') {
        img = img.replace(/_(small|compact|medium|100x100|150x150|200x200)\./, '_800x.');
      }

      let itemObj = {
        id: prodId,
        handle: prodHandle,
        title: prodTitle,
        price: parseFloat(prod ? (prod.price || 0) : 0),
        image: img || '',
        url: prod ? (prod.url || ('/products/' + prodHandle)) : ('/products/' + prodHandle)
      };

      list.push(itemObj);
      wishlistData[prodHandle] = itemObj;
      wishlistData[prodId] = itemObj;
    }

    const cleanList = dedupeWishlist(list);
    localStorage.setItem('aura_wishlist', JSON.stringify(cleanList));
    localStorage.setItem('auraWishlist', JSON.stringify(cleanList));
    localStorage.setItem('inklooma_wishlist', JSON.stringify(cleanList));
    localStorage.setItem('aura_wishlist_data', JSON.stringify(wishlistData));

    window.updateWishlistUI();
  };

  window.updateWishlistUI = function() {
    const list = window.getWishlist();
    const count = list.length;
    
    // 1. Update header badges (excluding header text)
    const countBadges = document.querySelectorAll('#wishlistCount, .wishlist-count, [data-wishlist-count]');
    countBadges.forEach(b => {
      b.textContent = count;
      b.style.cssText = 'position: absolute; top: 0px !important; right: -2px !important; background: #ff4d4d !important; color: #fff !important; font-size: 10px !important; font-weight: 900 !important; border-radius: 50% !important; width: 17px !important; height: 17px !important; display: ' + (count > 0 ? 'inline-flex' : 'none') + '!important; align-items: center !important; justify-content: center !important; z-index: 999 !important; border: 1.5px solid #08080a !important;';
    });

    const countHeader = document.getElementById('wishlistCountHeader');
    if (countHeader) {
      countHeader.textContent = count;
      countHeader.style.display = 'inline';
    }

    // 2. Ensure header wishlist icon has a badge if missing
    const headerWishlistLink = document.querySelector('#wishlistBtn, a[href*="wishlist"], [title="Wishlist"]');
    if (headerWishlistLink) {
      headerWishlistLink.style.overflow = 'visible';
      if (!headerWishlistLink.querySelector('#wishlistCount, .wishlist-count')) {
        headerWishlistLink.style.position = 'relative';
        const badge = document.createElement('span');
        badge.id = 'wishlistCount';
        badge.className = 'wishlist-count';
        badge.style.cssText = 'position: absolute; top: 0px !important; right: -2px !important; background: #ff4d4d !important; color: #fff !important; font-size: 10px !important; font-weight: 900 !important; border-radius: 50% !important; width: 17px !important; height: 17px !important; display: ' + (count > 0 ? 'inline-flex' : 'none') + '!important; align-items: center !important; justify-content: center !important; z-index: 999 !important; border: 1.5px solid #08080a !important;';
        badge.textContent = count;
        headerWishlistLink.appendChild(badge);
      }
    }

    // 3. Update ALL Product Card Heart Icons (Homepage, Collection Grid)
    const allCards = document.querySelectorAll('.product-card, product-card, .card-wrapper, .product-grid__item, [data-product-id]');
    allCards.forEach(card => {
      const cardId = card.getAttribute('data-product-id') || card.getAttribute('data-handle') || '';
      const cardTitleEl = card.querySelector('.product-title, [class*="product_title"], [class*="title"]');
      const cardTitle = cardTitleEl ? cardTitleEl.textContent.trim() : '';
      const cardObj = { id: cardId, handle: cardId, title: cardTitle };
      
      const wishBtn = card.querySelector('.btn-wishlist-card, .wishlist-btn, [class*="wishlist"]');
      if (wishBtn) {
        const isWish = window.isProductInWishlist(cardObj);
        if (isWish) {
          wishBtn.classList.add('active');
          const icon = wishBtn.querySelector('i');
          if (icon) {
            icon.className = 'fa-solid fa-heart';
            icon.style.color = '#ff4d4d';
          }
        } else {
          wishBtn.classList.remove('active');
          const icon = wishBtn.querySelector('i');
          if (icon) {
            icon.className = 'fa-regular fa-heart';
            icon.style.color = '';
          }
        }
      }
    });

    // 4. Update ALL QuickView Modal & PDP Standalone Heart Buttons
    let activeProduct = window.currentProductInModal;
    if (!activeProduct && window.auraShopifyProducts) {
      const pathHandle = window.location.pathname.split('/products/')[1] ? window.location.pathname.split('/products/')[1].replace(/\/$/, '') : '';
      if (pathHandle) {
        activeProduct = window.auraShopifyProducts.find(p => p.handle === pathHandle || String(p.id) === pathHandle);
      }
    }
    if (!activeProduct) {
      const pageTitle = document.querySelector('h1.product__title, h1.product-title, .product-single__title, meta[property="og:title"]')?.content || document.querySelector('h1')?.textContent || '';
      const pageHandle = window.location.pathname.split('/products/')[1] ? window.location.pathname.split('/products/')[1].replace(/\/$/, '') : '';
      if (pageTitle || pageHandle) {
        activeProduct = { handle: pageHandle, title: pageTitle.trim() };
      }
    }

    const pdpButtons = document.querySelectorAll('#modalWishlistBtn, .btn-wishlist-modal, .pdp-wishlist-btn, .product-form__wishlist, [data-action="wishlist"], button.wishlist-btn, button.btn-wishlist, [class*="wishlist-button"], [class*="wishlist-btn"], .product-form__buttons button:not([name="add"]):not([type="submit"])');
    pdpButtons.forEach(btn => {
      if (!btn.closest('.product-card') && !btn.closest('product-card')) {
        const isWish = activeProduct ? window.isProductInWishlist(activeProduct) : false;
        if (isWish) {
          btn.classList.add('active');
          btn.innerHTML = '<i class="fa-solid fa-heart" style="color: #ffffff !important; font-size: 20px;"></i>';
          btn.style.cssText = 'width: 54px !important; height: 54px !important; min-width: 54px !important; max-width: 54px !important; flex-shrink: 0 !important; border-radius: 14px !important; background: linear-gradient(135deg, #ff4d4d 0%, #dc2626 100%) !important; border: 1.5px solid #ff4d4d !important; color: #ffffff !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; box-shadow: 0 6px 22px rgba(239, 68, 68, 0.55) !important; transition: all 0.25s ease !important; cursor: pointer !important; margin: 0 !important; padding: 0 !important;';
        } else {
          btn.classList.remove('active');
          btn.innerHTML = '<i class="fa-regular fa-heart" style="color: #ffffff !important; font-size: 20px;"></i>';
          btn.style.cssText = 'width: 54px !important; height: 54px !important; min-width: 54px !important; max-width: 54px !important; flex-shrink: 0 !important; border-radius: 14px !important; background: rgba(255, 255, 255, 0.08) !important; border: 1.5px solid rgba(255, 255, 255, 0.18) !important; color: #ffffff !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; transition: all 0.25s ease !important; cursor: pointer !important; margin: 0 !important; padding: 0 !important;';
        }
      }
    });

    // 4. Populate Wishlist Drawer items list
    const wishlistItemsList = document.getElementById('wishlistItemsList');
    const emptyWishlistState = document.getElementById('emptyWishlistState');
    
    if (wishlistItemsList && emptyWishlistState) {
      if (count === 0) {
        emptyWishlistState.style.cssText = 'display: flex !important; flex-direction: column !important; align-items: center !important; text-align: center !important; padding: 40px 20px !important;';
        wishlistItemsList.style.display = 'none';
      } else {
        emptyWishlistState.style.display = 'none';
        wishlistItemsList.style.cssText = 'display: flex !important; flex-direction: column !important; gap: 14px !important;';
        wishlistItemsList.innerHTML = '';
        
        let wishlistData = {};
        try { wishlistData = JSON.parse(localStorage.getItem('aura_wishlist_data') || '{}'); } catch(e) {}

        list.forEach(item => {
          const handle = (typeof item === 'object' && item !== null) ? (item.handle || item.id) : item;
          const savedInfo = (typeof item === 'object' && item !== null) ? item : (wishlistData[handle] || null);
          const prod = (typeof shopifyProductsMap !== 'undefined' && shopifyProductsMap[handle]) ? shopifyProductsMap[handle] : savedInfo;
          
          let title = (savedInfo && savedInfo.title) ? savedInfo.title : ((prod && prod.title) ? prod.title : (typeof handle === 'string' ? handle.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : ''));
          
          let image = (savedInfo && savedInfo.image) ? savedInfo.image : ((prod && prod.image) ? prod.image : '');
          if (image && typeof image === 'string') {
            image = image.replace(/_(small|compact|medium|100x100|150x150|200x200)\./, '_800x.');
          }

          let price = '';
          if (savedInfo && savedInfo.price != null) {
            price = typeof savedInfo.price === 'number' ? '$' + savedInfo.price.toFixed(2) : savedInfo.price;
          } else if (prod && prod.price != null) {
            price = typeof prod.price === 'string' ? prod.price : '$' + parseFloat(prod.price).toFixed(2);
          }

          const itemTargetHandle = (typeof handle === 'object' && handle !== null) ? (handle.handle || handle.id) : handle;

          const div = document.createElement('div');
          div.className = 'wishlist-item';
          div.style.cssText = 'display:flex; gap:14px; align-items:center; background:#15151a; border:1px solid rgba(255,255,255,0.08); padding:12px; border-radius:10px; position:relative; cursor:pointer; transition: all 0.2s ease;';
          div.innerHTML = `
            <img src="${image || 'data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1 1%22></svg>'}" alt="${title}" style="width:60px; height:60px; object-fit:cover; border-radius:8px; flex-shrink:0;">
            <div style="flex:1;">
              <h4 style="color:#ffffff; font-size:14px; font-weight:700; margin:0 0 4px 0; line-height:1.3;">${title}</h4>
              <div style="color:#d4af37; font-weight:800; font-size:14px;">${price}</div>
            </div>
            <button class="remove-wish-item" onclick="event.stopPropagation(); window.toggleWishlist('${itemTargetHandle}');" style="background:none; border:none; color:#a1a1aa; cursor:pointer; font-size:18px; padding:6px; margin-left:8px;" title="Remove"><i class="fa-solid fa-xmark"></i></button>
          `;

          div.addEventListener('click', function(e) {
            if (e.target.closest('.remove-wish-item')) return;
            if (typeof window.closeWishlist === 'function') window.closeWishlist();
            setTimeout(function() {
              if (typeof window.openQuickView === 'function') {
                window.openQuickView(savedInfo || prod || itemTargetHandle);
              }
            }, 100);
          });

          wishlistItemsList.appendChild(div);
        });
      }
    }

    // 5. Robust Dual Matching Engine: ID + Handle + auraShopifyProducts for Heart Buttons
    const allCardHearts = document.querySelectorAll('.btn-wishlist-card, .btn-wishlist, .wishlist-btn, [data-wishlist-btn], .wishlist-icon-btn, .product-card .wishlist-btn, .product-image-box .btn-wishlist-card');
    allCardHearts.forEach(btn => {
      const cardProdId = btn.getAttribute('data-product-id') || btn.dataset.id || btn.dataset.productId;
      if (!cardProdId) return;

      const isWishlisted = list.some(item => {
        let itemHandle = (typeof item === 'object' && item !== null) ? String(item.handle || item.id) : String(item);
        let itemId = (typeof item === 'object' && item !== null) ? String(item.id || item.handle) : String(item);
        
        if (itemHandle === String(cardProdId) || itemId === String(cardProdId)) return true;

        if (window.auraShopifyProducts) {
          const matchProd = window.auraShopifyProducts.find(p => String(p.id) === String(cardProdId) || String(p.handle) === String(cardProdId));
          if (matchProd) {
            return String(matchProd.id) === itemHandle || String(matchProd.handle) === itemHandle || String(matchProd.id) === itemId || String(matchProd.handle) === itemId;
          }
        }
        return false;
      });

      if (isWishlisted) {
        btn.classList.add('active');
        btn.style.setProperty('background', '#ff4d4d', 'important');
        btn.style.setProperty('color', '#ffffff', 'important');
        btn.style.setProperty('box-shadow', '0 4px 14px rgba(255, 77, 77, 0.5)', 'important');
        const icon = btn.querySelector('i');
        if (icon) {
          icon.className = 'fa-solid fa-heart';
          icon.style.setProperty('color', '#ffffff', 'important');
        }
      } else {
        btn.classList.remove('active');
        btn.style.setProperty('background', 'rgba(0, 0, 0, 0.75)', 'important');
        btn.style.setProperty('color', '#ffffff', 'important');
        btn.style.setProperty('box-shadow', 'none', 'important');
        const icon = btn.querySelector('i');
        if (icon) {
          icon.className = 'fa-regular fa-heart';
          icon.style.setProperty('color', '#ffffff', 'important');
        }
      }
    });

  };

  window.openWishlist = function() {
    if (typeof window.closeCart === 'function') window.closeCart();
    const overlay = document.getElementById('wishlistOverlay');
    const drawer = document.getElementById('wishlistDrawer');
    if (overlay) overlay.classList.add('open');
    if (drawer) drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    window.updateWishlistUI();
  };

  window.closeWishlist = function() {
    const overlay = document.getElementById('wishlistOverlay');
    const drawer = document.getElementById('wishlistDrawer');
    if (overlay) overlay.classList.remove('open');
    if (drawer) drawer.classList.remove('open');
    document.body.style.overflow = '';
  };

  // Global Wishlist Event Listener
  document.addEventListener('click', function(e) {
    const modalWishlistBtn = e.target.closest('#modalWishlistBtn, .btn-wishlist-modal');
    if (modalWishlistBtn) {
      e.preventDefault();
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (window.currentProductInModal && window.toggleWishlist) {
        window.toggleWishlist(window.currentProductInModal.id, window.currentProductInModal);
      }
      return false;
    }

    const wishlistHeaderTarget = e.target.closest('#wishlistBtn, a[href*="wishlist"], [title="Wishlist"]');
    if (wishlistHeaderTarget && !modalWishlistBtn) {
      e.preventDefault();
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (window.openWishlist) window.openWishlist();
      return false;
    }
  }, true);

  // Initialize Wishlist state on load
  document.addEventListener('DOMContentLoaded', function() {
    window.updateWishlistUI();
  });

  function removeFromCart(index) {
    cart.splice(index, 1);
    updateCartUI();
  }

  function changeQuantity(index, delta) {
    const item = cart[index];
    if (!item) return;

    item.quantity += delta;
    if (item.quantity <= 0) {
      removeFromCart(index);
    } else {
      updateCartUI();
    }
  }

  // --- Cart & Server Sync Logic ---
  async function syncCartToShopifyServer() {
    if (window.location.protocol.startsWith('file')) return;
    try {
      if (!cart || cart.length === 0) return;
      
      const itemsPayload = [];
      cart.forEach(item => {
        const vId = item.variantId || item.id;
        if (vId) {
          itemsPayload.push({
            id: vId,
            quantity: item.quantity || 1
          });
        }
      });

      if (itemsPayload.length > 0) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsPayload })
        }).catch(() => {});
      }
    } catch(err) {
      console.warn('[Cart Sync] Server sync fallback:', err);
    }
  }

  // --- Checkout Logic ---
  let checkoutItems = [];

  async function openCheckout(e, singleProductItem = null) {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
      e.stopPropagation();
    }

    if (singleProductItem) {
      checkoutItems = [singleProductItem];
    } else {
      if (cart.length === 0) {
        closeCart();
        return false;
      }
      checkoutItems = [...cart];
    }
    
    // Save scroll position before closing cart drawer
    saveScrollPosition();
    
    const isLocal = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost' || window.location.protocol.startsWith('file');
    
    if (!isLocal) {
      const checkoutBtnEl = document.getElementById('checkoutBtn');
      if (checkoutBtnEl) {
        checkoutBtnEl.disabled = true;
        checkoutBtnEl.textContent = 'CHECKING OUT...';
      }
      // Guarantee Shopify server cart is synced before redirecting to /checkout so it never bounces back to home!
      await syncCartToShopifyServer();
      window.location.href = '/checkout';
      return false;
    }

    // Check if checkout elements exist in DOM (for local standalone testing)
    if (!checkoutItemsList || !checkoutSubtotal || !checkoutTaxes || !checkoutGrandTotal || !checkoutOverlay || !checkoutGrid || !checkoutSuccessSection || !checkoutForm) {
      await syncCartToShopifyServer();
      window.location.href = '/checkout';
      return false;
    }

    closeCart();
    
    // Populate summary items
    checkoutItemsList.innerHTML = '';
    let subtotal = 0;
    checkoutItems.forEach(item => {
      subtotal += item.price * item.quantity;
      const itemEl = document.createElement('div');
      itemEl.classList.add('checkout-item');
      itemEl.innerHTML = `
        <img src="${item.image}" alt="${item.title}" class="checkout-item-img">
        <div class="checkout-item-details">
          <div class="checkout-item-title">${item.title}</div>
          <div class="checkout-item-variant">${item.color || 'Default'} / ${item.size || 'M'}</div>
          <div class="checkout-item-qty-price">${item.quantity} x $${item.price.toFixed(2)}</div>
        </div>
      `;
      checkoutItemsList.appendChild(itemEl);
    });

    const taxRate = 0.08; // 8% sales tax
    const tax = subtotal * taxRate;
    const total = subtotal + tax;

    checkoutSubtotal.textContent = `$${subtotal.toFixed(2)}`;
    checkoutTaxes.textContent = `$${tax.toFixed(2)}`;
    checkoutGrandTotal.textContent = `$${total.toFixed(2)}`;

    // Reset views
    checkoutGrid.style.display = 'grid';
    checkoutSuccessSection.style.display = 'none';
    checkoutForm.reset();
    
    // Default payment options UI state
    if (paymentOptCard) paymentOptCard.classList.add('active');
    if (paymentOptCOD) paymentOptCOD.classList.remove('active');
    if (cardDetailsSection) cardDetailsSection.style.display = 'block';
    
    // Require card inputs initially
    toggleCardInputsRequired(true);

    // Open modal
    checkoutOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    return false;
  }

  function closeCheckout() {
    checkoutOverlay.classList.remove('open');
    document.body.style.overflow = '';
    restoreScrollPosition();
  }

  function toggleCardInputsRequired(required) {
    const cardNum = document.getElementById('checkoutCardNumber');
    const cardExpiry = document.getElementById('checkoutCardExpiry');
    const cardCVC = document.getElementById('checkoutCardCVC');
    if (cardNum && cardExpiry && cardCVC) {
      cardNum.required = required;
      cardExpiry.required = required;
      cardCVC.required = required;
    }
  }

  // Bind Open Checkout to checkoutBtn
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', openCheckout);
  }

  // Bind Close Checkout
  if (checkoutCloseBtn) checkoutCloseBtn.addEventListener('click', closeCheckout);
  if (checkoutOverlay) {
    checkoutOverlay.addEventListener('click', (e) => {
      if (e.target === checkoutOverlay) {
        closeCheckout();
      }
    });
  }

  // Payment method toggles
  if (paymentOptCard && paymentOptCOD) {
    const cardRadio = paymentOptCard.querySelector('input[type="radio"]');
    const codRadio = paymentOptCOD.querySelector('input[type="radio"]');

    paymentOptCard.addEventListener('click', () => {
      paymentOptCard.classList.add('active');
      paymentOptCOD.classList.remove('active');
      cardDetailsSection.style.display = 'block';
      cardRadio.checked = true;
      toggleCardInputsRequired(true);
    });

    paymentOptCOD.addEventListener('click', () => {
      paymentOptCOD.classList.add('active');
      paymentOptCard.classList.remove('active');
      cardDetailsSection.style.display = 'none';
      codRadio.checked = true;
      toggleCardInputsRequired(false);
    });
  }

  // Form Submission
  if (checkoutForm) {
    checkoutForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const email = document.getElementById('checkoutEmail').value;
      const firstName = document.getElementById('checkoutFirstName').value;
      const lastName = document.getElementById('checkoutLastName').value;
      const address = document.getElementById('checkoutAddress').value;
      const city = document.getElementById('checkoutCity').value;
      const zip = document.getElementById('checkoutZip').value;
      const paymentMethod = checkoutForm.querySelector('input[name="paymentMethod"]:checked').value;

      const submitBtn = document.getElementById('checkoutSubmitBtn');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Processing Securely...';

      // Simulate a small delay for verification
      setTimeout(() => {
        // Clear submit processing status
        submitBtn.disabled = false;
        submitBtn.textContent = 'Place Order';

        // Set success info
        const orderNum = '#' + Math.floor(1000 + Math.random() * 9000);
        successOrderNumber.textContent = orderNum;
        successEmail.textContent = email;
        successName.textContent = `${firstName} ${lastName}`;
        successAddress.textContent = `${address}, ${city}, ${zip}`;
        successPaymentMethod.textContent = paymentMethod === 'card' ? 'Credit Card' : 'Cash on Delivery (COD)';

        // Switch screens in modal
        checkoutGrid.style.display = 'none';
        checkoutSuccessSection.style.display = 'block';
        
        // Scroll to top of modal container
        checkoutModal.scrollTop = 0;

        // Add to order history
        const orderTotal = checkoutItems.reduce((sum, item) => sum + item.price * item.quantity, 0) * 1.08; // subtotal + 8% tax
        const newOrder = {
          id: orderNum,
          date: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }),
          items: checkoutItems.map(item => ({
            title: item.title,
            color: item.color,
            size: item.size,
            quantity: item.quantity
          })),
          total: orderTotal,
          status: "Processing"
        };
        
        userOrders.push(newOrder);
        localStorage.setItem('mockOrders', JSON.stringify(userOrders));
        if (typeof renderDashboardOrders === 'function') {
          renderDashboardOrders();
        }

        // Clear cart ONLY if this checkout matches the cart contents
        const isCartCheckout = (checkoutItems.length === cart.length && checkoutItems.every((val, idx) => 
          val.id === cart[idx].id && val.color === cart[idx].color && val.size === cart[idx].size
        ));
        if (isCartCheckout) {
          cart = [];
          updateCartUI();
        }
      }, 1500);
    });
  }

  if (checkoutSuccessCloseBtn) {
    checkoutSuccessCloseBtn.addEventListener('click', closeCheckout);
  }

  function closeQuickView() {
    quickViewOverlay.classList.remove('open');
    if (!cartDrawer.classList.contains('open')) {
      document.body.style.overflow = '';
      restoreScrollPosition();
    }
    currentProductInModal = null;
  }

  if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeQuickView);
  if (quickViewOverlay) {
    quickViewOverlay.addEventListener('click', (e) => {
      if (e.target === quickViewOverlay) {
        closeQuickView();
      }
    });
  }

  if (modalQtyMinus) {
    modalQtyMinus.addEventListener('click', () => {
      if (modalQty > 1) {
        modalQty--;
        modalQtyVal.textContent = modalQty;
      }
    });
  }

  if (modalQtyPlus) {
    modalQtyPlus.addEventListener('click', () => {
      modalQty++;
      modalQtyVal.textContent = modalQty;
    });
  }

  if (modalAddToCartBtn) {
    modalAddToCartBtn.addEventListener('click', () => {
      if (currentProductInModal) {
        addToCart(currentProductInModal.id, modalQty);
      }
    });
  }

  const searchBtn = document.getElementById('searchBtn');
  const userBtn = document.getElementById('userBtn');
  const wishlistBtn = document.getElementById('wishlistBtn');
  const newsletterForm = document.getElementById('newsletterForm');

  // ==========================================
  // --- Wishlist Functionality (Shopify-like) ---
  // ==========================================
  wishlist = JSON.parse(localStorage.getItem('mockWishlist') || '[]');

  function saveWishlist() {
    localStorage.setItem('mockWishlist', JSON.stringify(wishlist));
    updateWishlistUI();
  }

  const wishlistCountBadge = document.getElementById('wishlistCount');
  const wishlistCountHeader = document.getElementById('wishlistCountHeader');
  const wishlistDrawer = document.getElementById('wishlistDrawer');
  const wishlistOverlay = document.getElementById('wishlistOverlay');
  const wishlistCloseBtn = document.getElementById('wishlistCloseBtn');
  const wishlistContinueBtn = document.getElementById('wishlistContinueBtn');
  const wishlistItemsList = document.getElementById('wishlistItemsList');
  const emptyWishlistState = document.getElementById('emptyWishlistState');

  function openWishlist() {
    saveScrollPosition();
    wishlistOverlay.classList.add('open');
    wishlistDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeWishlist() {
    wishlistOverlay.classList.remove('open');
    wishlistDrawer.classList.remove('open');
    document.body.style.overflow = '';
    restoreScrollPosition();
  }

  if (wishlistBtn) wishlistBtn.addEventListener('click', openWishlist);
  if (wishlistCloseBtn) wishlistCloseBtn.addEventListener('click', closeWishlist);
  if (wishlistOverlay) wishlistOverlay.addEventListener('click', closeWishlist);
  if (wishlistContinueBtn) wishlistContinueBtn.addEventListener('click', (e) => {
    e.preventDefault();
    closeWishlist();
  });

  // Universal Wishlist Heart Click Delegate
  document.addEventListener('click', function(e) {
    const heartBtn = e.target.closest('.btn-wishlist-card, .btn-wishlist, .wishlist-btn, [data-wishlist-btn], .icon-wishlist, .wishlist-icon');
    if (heartBtn) {
      e.preventDefault();
      e.stopPropagation();
      const productId = heartBtn.getAttribute('data-product-id') || heartBtn.dataset.id || heartBtn.dataset.productId;
      if (productId && window.toggleWishlist) {
        window.toggleWishlist(productId);
      }
    }
  });

  // ==========================================
  // --- Search Functionality (Shopify-like) ---
  // ==========================================
  const searchOverlay = document.getElementById('searchOverlay');
  const searchCloseBtn = document.getElementById('searchCloseBtn');
  const searchInput = document.getElementById('searchInput');
  const searchClearBtn = document.getElementById('searchClearBtn');
  const searchSuggestions = document.getElementById('searchSuggestions');
  const searchResultsWrapper = document.getElementById('searchResultsWrapper');
  const searchResultsTitle = document.getElementById('searchResultsTitle');
  const searchResultsGrid = document.getElementById('searchResultsGrid');

  function openSearch() {
    saveScrollPosition();
    searchOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput.focus(), 100);
  }

  function closeSearch() {
    searchOverlay.classList.remove('open');
    document.body.style.overflow = '';
    restoreScrollPosition();
    searchInput.value = '';
    searchClearBtn.style.display = 'none';
    searchResultsWrapper.style.display = 'none';
    searchSuggestions.style.display = 'block';
  }

  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
  
  if (searchOverlay) {
    searchOverlay.addEventListener('click', (e) => {
      if (e.target === searchOverlay) {
        closeSearch();
      }
    });
  }

  if (searchClearBtn) {
    searchClearBtn.addEventListener('click', () => {
      searchInput.value = '';
      searchInput.focus();
      searchClearBtn.style.display = 'none';
      searchResultsWrapper.style.display = 'none';
      searchSuggestions.style.display = 'block';
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      const query = searchInput.value.trim().toLowerCase();
      if (!query) {
        searchClearBtn.style.display = 'none';
        searchResultsWrapper.style.display = 'none';
        searchSuggestions.style.display = 'block';
        return;
      }

      searchClearBtn.style.display = 'block';
      searchSuggestions.style.display = 'none';
      searchResultsWrapper.style.display = 'block';

      // Search matching titles, vendors, descriptions
      const results = Object.values(productsData).filter(p => 
        p.title.toLowerCase().includes(query) || 
        p.vendor.toLowerCase().includes(query) || 
        p.desc.toLowerCase().includes(query)
      );

      searchResultsTitle.textContent = `Search Results (${results.length})`;
      searchResultsGrid.innerHTML = '';

      if (results.length === 0) {
        searchResultsGrid.innerHTML = `<div style="grid-column: 1/-1; text-align: center; color: var(--color-text-muted); padding: 30px 0;">No designs match "${searchInput.value}".</div>`;
      } else {
        results.forEach(product => {
          const card = document.createElement('div');
          card.classList.add('search-result-card');
          card.innerHTML = `
            <img src="${product.image}" alt="${product.title}" class="search-result-image">
            <div class="search-result-info">
              <div class="search-result-title">${product.title}</div>
              <div class="search-result-price">$${product.price.toFixed(2)}</div>
            </div>
          `;
          
          card.setAttribute('data-product-id', product.id);
          card.setAttribute('data-url', product.url || `/products/${product.handle || product.id}`);

          card.addEventListener('click', (e) => {
            e.preventDefault();
            if (typeof closeSearch === 'function') closeSearch();
            if (typeof closeAuraSearch === 'function') closeAuraSearch();
            
            const qvModal = document.getElementById('quickViewOverlay');
            if (qvModal && typeof window.openQuickView === 'function') {
              window.openQuickView(product.id);
            } else {
              const targetUrl = product.url || `/products/${product.handle || product.id}`;
              window.location.href = targetUrl;
            }
          });
          
          searchResultsGrid.appendChild(card);
        });
      }
    });
  }

  // --- Size Chart Modal Controller ---
  const sizeChartOverlay = document.getElementById('sizeChartOverlay');
  const sizeChartCloseBtn = document.getElementById('sizeChartCloseBtn');

  function openSizeChart() {
    if (sizeChartOverlay) {
      sizeChartOverlay.classList.add('open');
      sizeChartOverlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  }

  function closeSizeChart() {
    if (sizeChartOverlay) {
      sizeChartOverlay.classList.remove('open');
      sizeChartOverlay.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  if (sizeChartCloseBtn) sizeChartCloseBtn.addEventListener('click', closeSizeChart);
  if (sizeChartOverlay) {
    sizeChartOverlay.addEventListener('click', (e) => {
      if (e.target === sizeChartOverlay) closeSizeChart();
    });
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('.btn-size-chart')) {
      e.preventDefault();
      openSizeChart();
    }
  });

  window.openSizeChart = openSizeChart;
  document.querySelectorAll('.suggestion-tag').forEach(tag => {
    tag.addEventListener('click', () => {
      const term = tag.textContent.trim();
      if (searchInput) {
        searchInput.value = term;
        // Trigger input event programmatically
        searchInput.dispatchEvent(new Event('input'));
      }
    });
  });

  // ==========================================
  // --- Account Portal Functionality ---
  // ==========================================
  const accountOverlay = document.getElementById('accountOverlay');
  const accountCloseBtn = document.getElementById('accountCloseBtn');
  const loginView = document.getElementById('loginView');
  const signupView = document.getElementById('signupView');
  const accountGrid = document.getElementById('accountGrid');
  const accountDashboard = document.getElementById('accountDashboard');
  const showSignUpLink = document.getElementById('showSignUpLink');
  const showLoginLink = document.getElementById('showLoginLink');
  const loginForm = document.getElementById('loginForm');
  const signupForm = document.getElementById('signupForm');
  const logoutBtn = document.getElementById('logoutBtn');

  const dashUserName = document.getElementById('dashUserName');
  const dashUserEmail = document.getElementById('dashUserEmail');
  const dashAddress = document.getElementById('dashAddress');
  const dashboardOrdersList = document.getElementById('dashboardOrdersList');

  // Load account orders or define template
  let userOrders = JSON.parse(localStorage.getItem('mockOrders') || '[]');

  function openAccount() {
    saveScrollPosition();
    accountOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    
    // Check if user is logged in
    const currentUser = JSON.parse(localStorage.getItem('mockUser'));
    if (currentUser) {
      showDashboard(currentUser);
    } else {
      showLoginForm();
    }
  }

  function closeAccount() {
    accountOverlay.classList.remove('open');
    document.body.style.overflow = '';
    restoreScrollPosition();
  }

  if (userBtn) userBtn.addEventListener('click', openAccount);
  if (accountCloseBtn) accountCloseBtn.addEventListener('click', closeAccount);
  if (accountOverlay) {
    accountOverlay.addEventListener('click', (e) => {
      if (e.target === accountOverlay) {
        closeAccount();
      }
    });
  }

  function showLoginForm() {
    accountGrid.style.display = 'grid';
    accountDashboard.style.display = 'none';
    loginView.style.display = 'block';
    signupView.style.display = 'none';
    const forgotView = document.getElementById('forgotPassView');
    if (forgotView) forgotView.style.display = 'none';
  }

  function showSignUpForm() {
    accountGrid.style.display = 'grid';
    accountDashboard.style.display = 'none';
    loginView.style.display = 'none';
    signupView.style.display = 'block';
    const forgotView = document.getElementById('forgotPassView');
    if (forgotView) forgotView.style.display = 'none';
  }

  function showForgotPassForm() {
    accountGrid.style.display = 'grid';
    accountDashboard.style.display = 'none';
    loginView.style.display = 'none';
    signupView.style.display = 'none';
    const forgotView = document.getElementById('forgotPassView');
    if (forgotView) forgotView.style.display = 'block';
  }

  if (showSignUpLink) showSignUpLink.addEventListener('click', (e) => { e.preventDefault(); showSignUpForm(); });
  if (showLoginLink) showLoginLink.addEventListener('click', (e) => { e.preventDefault(); showLoginForm(); });

  document.addEventListener('click', function(e) {
    const forgotLink = e.target.closest('#forgotPassLink, .forgot-pass-link');
    if (forgotLink) {
      e.preventDefault();
      showForgotPassForm();
    }
    const backToLogin = e.target.closest('#backToLoginFromForgot');
    if (backToLogin) {
      e.preventDefault();
      showLoginForm();
    }
  });

  const forgotPassForm = document.getElementById('forgotPassForm');
  if (forgotPassForm) {
    forgotPassForm.addEventListener('submit', function(e) {
      const successMsg = document.getElementById('forgotPassSuccess');
      if (successMsg) successMsg.style.display = 'block';
    });
  }

  function showDashboard(user) {
    accountGrid.style.display = 'none';
    accountDashboard.style.display = 'block';
    if (dashUserName) dashUserName.textContent = user.name;
    if (dashUserEmail) dashUserEmail.textContent = user.email;
    if (dashAddress) dashAddress.textContent = user.address || "123 Cosmic Way, Nebula City, NY 10001";
    renderDashboardOrders();
  }

  function renderDashboardOrders() {
    if (!dashboardOrdersList) return;
    
    dashboardOrdersList.innerHTML = '';
    
    if (userOrders.length === 0) {
      dashboardOrdersList.innerHTML = '<div class="no-orders-msg">You have not placed any orders yet.</div>';
    } else {
      // Reverse order to show newest orders first
      [...userOrders].reverse().forEach(order => {
        const orderEl = document.createElement('div');
        orderEl.classList.add('order-history-item');
        
        let prodsHtml = '';
        order.items.forEach(item => {
          prodsHtml += `
            <div class="order-history-prod">
              <span class="order-history-prod-name">${item.title} (${item.color} / ${item.size})</span>
              <span>x${item.quantity}</span>
            </div>
          `;
        });

        orderEl.innerHTML = `
          <div class="order-history-header">
            <span class="order-history-id">Order ID: ${order.id}</span>
            <span class="order-history-date">${order.date}</span>
          </div>
          <div class="order-history-products">
            ${prodsHtml}
          </div>
          <div class="order-history-footer">
            <span class="order-history-status status-processing">${order.status}</span>
            <span class="order-history-total">$${order.total.toFixed(2)}</span>
          </div>
        `;
        dashboardOrdersList.appendChild(orderEl);
      });
    }
  }

  if (loginForm) {
    loginForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = document.getElementById('loginEmail').value;
      
      const mockUser = {
        name: email.split('@')[0].toUpperCase(),
        email: email,
        address: "123 Cosmic Way, Nebula City, NY 10001"
      };
      
      localStorage.setItem('mockUser', JSON.stringify(mockUser));
      showDashboard(mockUser);
    });
  }

  if (signupForm) {
    signupForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const name = document.getElementById('signupName').value;
      const email = document.getElementById('signupEmail').value;
      
      const mockUser = {
        name: name,
        email: email,
        address: "123 Cosmic Way, Nebula City, NY 10001"
      };
      
      localStorage.setItem('mockUser', JSON.stringify(mockUser));
      showDashboard(mockUser);
    });
  }

  if (logoutBtn) {
    logoutBtn.addEventListener('click', () => {
      localStorage.removeItem('mockUser');
      showLoginForm();
    });
  }

  // --- Initialize Wishlist UI and load saved states ---
  updateWishlistUI();

  // --- Direct Single Product Checkout Helper ---
  function getShopifyVariantId(productId, size = "M", color = "Navy Blue") {
    let product = productsData[productId];
    if (!product) return null;

    if (product.realProduct) {
      const realProduct = product.realProduct;
      if (realProduct.variants && realProduct.variants.length > 0) {
        const match = realProduct.variants.find(v => {
          const vTitle = v.title.toLowerCase();
          const hasSize = !size || vTitle.includes(size.toLowerCase());
          const hasColor = !color || vTitle.includes(color.toLowerCase());
          return hasSize && hasColor;
        });
        return match ? match.id : realProduct.variants[0].id;
      } else {
        return realProduct.variants[0].id;
      }
    } else {
      const normTitle = product.title.toLowerCase().trim();
      const realProduct = shopifyProductsMap[normTitle];

      if (realProduct) {
        if (realProduct.variants && realProduct.variants.length > 0) {
          const match = realProduct.variants.find(v => {
            const vTitle = v.title.toLowerCase();
            const hasSize = !size || vTitle.includes(size.toLowerCase());
            const hasColor = !color || vTitle.includes(color.toLowerCase());
            return hasSize && hasColor;
          });
          return match ? match.id : realProduct.variants[0].id;
        } else {
          return realProduct.variants[0].id;
        }
      } else {
        const firstRealProduct = Object.values(shopifyProductsMap)[0];
        if (firstRealProduct) {
          return firstRealProduct.variants[0].id;
        }
      }
    }
    return null;
  }

  window.openSingleProductCheckout = function(productId) {
    const product = productsData[productId];
    if (!product) return;

    const isLocal = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost' || window.location.protocol.startsWith('file');

    if (!isLocal) {
      const variantId = getShopifyVariantId(productId, "M", "Navy Blue");
      if (variantId) {
        window.location.href = `/cart/${variantId}:1`;
        return;
      }
    }

    openCheckout({
      id: product.id,
      title: product.title,
      price: product.price,
      image: product.image,
      quantity: 1,
      size: "M",
      color: "Navy Blue"
    });
  };

  // --- Dynamic Promo Banner Carousel ---
  const promoSlides = [
    {
      productId: 28,
      tag: "Luxury Jewelry",
      title: "Ethereal Four Leaf Clover",
      desc: "Handcrafted 24-karat solid gold pendant featuring an ethereal four-leaf clover design. Symbol of good fortune and luxury."
    },
    {
      productId: 1,
      tag: "Wilderness Edition",
      title: "Celestial White Stag Starry Lake",
      desc: "A legendary white stag wandering by a mystical starry lake. Soft-toned majestic fantasy graphic print."
    },
    {
      productId: 15,
      tag: "Zen & Minimalist",
      title: "Zen Golden Sun & Drifting Clouds",
      desc: "A clean minimalist zen design featuring soft drifting clouds and a bold metallic-looking gold sun."
    },
    {
      productId: 25,
      tag: "Abstract Landscapes",
      title: "Desert Sand Dunes Landscape",
      desc: "Warm gold and terra cotta desert sand dunes flowing in sleek minimalist waves. Clean modern landscape."
    },
    {
      productId: 3,
      tag: "Wilderness Series",
      title: "Mystic Howling Wolf Aurora Moon",
      desc: "A magical howling wolf silhouetted against a vibrant glowing green aurora borealis and a full cosmic moon."
    }
  ];

  const promoCardDynamic = document.getElementById('promoCardDynamic');
  const promoBgDynamic = document.getElementById('promoBgDynamic');
  const promoTagDynamic = document.getElementById('promoTagDynamic');
  const promoTitleDynamic = document.getElementById('promoTitleDynamic');
  const promoDescDynamic = document.getElementById('promoDescDynamic');
  const promoBtnDynamic = document.getElementById('promoBtnDynamic');
  const promoDotsContainer = document.getElementById('promoDotsContainer');

  let currentPromoSlideIndex = 0;
  let promoIntervalId = null;

  function initPromoCarousel() {
    if (!promoCardDynamic) return;

    // Build dots
    if (promoDotsContainer) {
      promoDotsContainer.innerHTML = '';
      promoSlides.forEach((_, idx) => {
        const dot = document.createElement('div');
        dot.classList.add('promo-dot');
        if (idx === 0) dot.classList.add('active');
        dot.addEventListener('click', () => {
          goToPromoSlide(idx);
          resetPromoInterval();
        });
        promoDotsContainer.appendChild(dot);
      });
    }

    // Set initial button click handler
    if (promoBtnDynamic) {
      promoBtnDynamic.addEventListener('click', (e) => {
        e.preventDefault();
        const currentSlide = promoSlides[currentPromoSlideIndex];
        if (typeof window.openSingleProductCheckout === 'function') {
          window.openSingleProductCheckout(currentSlide.productId);
        }
      });
    }

    startPromoInterval();
  }

  function updatePromoSlide(index) {
    if (!promoCardDynamic) return;
    
    currentPromoSlideIndex = index;
    const slide = promoSlides[index];
    const product = productsData[slide.productId];
    if (!product) return;

    // Add transitioning class for fade out
    promoCardDynamic.classList.add('transitioning');

    setTimeout(() => {
      // Update elements
      if (promoBgDynamic) {
        promoBgDynamic.src = product.image;
        promoBgDynamic.alt = product.title;
      }
      if (promoTagDynamic) promoTagDynamic.textContent = slide.tag;
      if (promoTitleDynamic) promoTitleDynamic.textContent = slide.title;
      if (promoDescDynamic) promoDescDynamic.textContent = slide.desc;
      if (promoBtnDynamic) {
        promoBtnDynamic.textContent = `Explore ${slide.title.replace("AOP T-Shirt", "").replace("T-Shirt", "").replace("Graphic Apparel", "").trim()}`;
      }

      // Update dots active class
      if (promoDotsContainer) {
        const dots = promoDotsContainer.querySelectorAll('.promo-dot');
        dots.forEach((dot, idx) => {
          if (idx === index) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      // Remove transitioning class for fade in
      promoCardDynamic.classList.remove('transitioning');
    }, 400);
  }

  function goToPromoSlide(index) {
    updatePromoSlide(index);
  }

  function startPromoInterval() {
    promoIntervalId = setInterval(() => {
      let nextIndex = (currentPromoSlideIndex + 1) % promoSlides.length;
      updatePromoSlide(nextIndex);
    }, 5000); // every 5 seconds
  }

  function resetPromoInterval() {
    if (promoIntervalId) {
      clearInterval(promoIntervalId);
    }
    startPromoInterval();
  }

  // Initialize the carousel
  initPromoCarousel();

  // --- Select Collection Action ---
  window.selectCollection = function(category) {
    const tabBtn = Array.from(tabBtns).find(btn => btn.getAttribute('data-category') === category);
    if (tabBtn) {
      tabBtn.click();
    }
    const productsSection = document.getElementById('new-arrivals');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // --- Collection Banner Carousel (Banner 2) ---
  const collectionSlides = [
    {
      category: "wilderness",
      productId: 1,
      tag: "Wilderness & Wildlife",
      title: "Ethereal White Stag Celestial",
      desc: "Wander deep into the wild with high-definition prints of forest stags, grizzly bears, and soaring eagles."
    },
    {
      category: "zen",
      productId: 10,
      tag: "Zen & Minimalist Art",
      title: "Zen Drifting Clouds & Sun",
      desc: "Traditional sumi-e ink bamboo, clean line ginkgo leaves, and geometric terrazzo patterns for clean styling."
    },
    {
      category: "landscapes",
      productId: 20,
      tag: "Abstract & Landscapes",
      title: "Abstract Sand Dunes Desert",
      desc: "Artistic watercolor desert sunsets, pine branch silhouettes, and dramatic monochromatic storm clouds."
    },
    {
      category: "pendants",
      productId: 28,
      tag: "Luxury Jewelry",
      title: "Ethereal Four Leaf Clover Pendant",
      desc: "Handcrafted solid 24k gold, sterling silver, and deep green jadeite clovers wrapped in gold wire frames."
    }
  ];

  const promoCardCollection = document.getElementById('promoCardCollection');
  const promoBgCollection = document.getElementById('promoBgCollection');
  const promoTagCollection = document.getElementById('promoTagCollection');
  const promoTitleCollection = document.getElementById('promoTitleCollection');
  const promoDescCollection = document.getElementById('promoDescCollection');
  const promoBtnCollection = document.getElementById('promoBtnCollection');
  const promoDotsCollectionContainer = document.getElementById('promoDotsCollectionContainer');

  let currentCollectionSlideIndex = 0;
  let collectionIntervalId = null;

  function initCollectionCarousel() {
    if (!promoCardCollection) return;

    // Build dots
    if (promoDotsCollectionContainer) {
      promoDotsCollectionContainer.innerHTML = '';
      collectionSlides.forEach((_, idx) => {
        const dot = document.createElement('div');
        dot.classList.add('promo-dot');
        if (idx === 0) dot.classList.add('active');
        dot.addEventListener('click', () => {
          goToCollectionSlide(idx);
          resetCollectionInterval();
        });
        promoDotsCollectionContainer.appendChild(dot);
      });
    }

    // Set click handler for collection button
    if (promoBtnCollection) {
      promoBtnCollection.addEventListener('click', (e) => {
        e.preventDefault();
        const currentSlide = collectionSlides[currentCollectionSlideIndex];
        if (typeof window.selectCollection === 'function') {
          window.selectCollection(currentSlide.category);
        }
      });
    }

    // Start auto cycle
    startCollectionInterval();
  }

  function updateCollectionSlide(index) {
    if (!promoCardCollection) return;

    currentCollectionSlideIndex = index;
    const slide = collectionSlides[index];
    const product = productsData[slide.productId];
    if (!product) return;

    // Add transitioning class for fade out
    promoCardCollection.classList.add('transitioning');

    setTimeout(() => {
      // Update elements
      if (promoBgCollection) {
        promoBgCollection.src = product.image;
        promoBgCollection.alt = product.title;
      }
      if (promoTagCollection) promoTagCollection.textContent = slide.tag;
      if (promoTitleCollection) promoTitleCollection.textContent = slide.title;
      if (promoDescCollection) promoDescCollection.textContent = slide.desc;
      if (promoBtnCollection) {
        promoBtnCollection.textContent = `View ${slide.tag.replace("Edition", "").replace("Odyssey", "").replace("Series", "").replace("Classics", "").trim()} Catalog`;
      }

      // Update dots active class
      if (promoDotsCollectionContainer) {
        const dots = promoDotsCollectionContainer.querySelectorAll('.promo-dot');
        dots.forEach((dot, idx) => {
          if (idx === index) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      // Remove transitioning class for fade in
      promoCardCollection.classList.remove('transitioning');
    }, 400);
  }

  function goToCollectionSlide(index) {
    updateCollectionSlide(index);
  }

  function startCollectionInterval() {
    collectionIntervalId = setInterval(() => {
      let nextIndex = (currentCollectionSlideIndex + 1) % collectionSlides.length;
      updateCollectionSlide(nextIndex);
    }, 5000); // every 5 seconds
  }

  function resetCollectionInterval() {
    if (collectionIntervalId) {
      clearInterval(collectionIntervalId);
    }
    startCollectionInterval();
  }

  // Initialize the carousel
  initCollectionCarousel();

  // --- Inklooma.shop PDP & Global Storefront Enhancements ---
  function applyAmbientBackgroundGlobal() {
    let styleEl = document.getElementById('auraAmbientGlowStyleDynamic');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'auraAmbientGlowStyleDynamic';
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = `
      html, body,
      body.template-product,
      body[class*="template-product"],
      main, #MainContent, #main-content,
      .shopify-section, .shopify-section > div, .section,
      .product, .product-single, .product-section,
      .product__media-wrapper, .product__info-wrapper,
      .product-single__media, .product-single__info,
      .product__info-container, [class*="product-section"],
      .page-width, .grid__item, .gradient {
        background-color: #060609 !important;
        background-image: 
          radial-gradient(circle at 15% 15%, rgba(212, 175, 55, 0.18) 0%, transparent 45%),
          radial-gradient(circle at 85% 25%, rgba(56, 189, 248, 0.14) 0%, transparent 50%),
          radial-gradient(circle at 50% 60%, rgba(212, 175, 55, 0.16) 0%, transparent 55%),
          radial-gradient(circle at 80% 85%, rgba(168, 85, 247, 0.12) 0%, transparent 50%),
          linear-gradient(180deg, #060609 0%, #0c0d13 35%, #08090e 70%, #040406 100%) !important;
        background-attachment: fixed !important;
        background-size: cover !important;
        color: #e4e4e7 !important;
      }
    `;
    if (document.body) {
      document.body.style.setProperty('background-color', '#060609', 'important');
      document.body.style.setProperty('background-image', 'radial-gradient(circle at 15% 15%, rgba(212, 175, 55, 0.18) 0%, transparent 45%), radial-gradient(circle at 85% 25%, rgba(56, 189, 248, 0.14) 0%, transparent 50%), radial-gradient(circle at 50% 60%, rgba(212, 175, 55, 0.16) 0%, transparent 55%), radial-gradient(circle at 80% 85%, rgba(168, 85, 247, 0.12) 0%, transparent 50%), linear-gradient(180deg, #060609 0%, #0c0d13 35%, #08090e 70%, #040406 100%)', 'important');
      document.body.style.setProperty('background-attachment', 'fixed', 'important');
      document.body.style.setProperty('background-size', 'cover', 'important');
    }
  }
  applyAmbientBackgroundGlobal();

  function initPDPFeatures() {
    applyAmbientBackgroundGlobal();
    const isPDP = window.location.pathname.includes('/products/');

    // Ensure header bar and announcement ticker are visible and active across all pages
    const customHeaders = document.querySelectorAll('.aura-custom-header, #siteHeader, .site-header, .announcement-bar');
    customHeaders.forEach(function(el) {
      if (el) el.style.setProperty('display', 'block', 'important');
    });
    
    // 1. Safe Header Wishlist Icon Override & Counter Badge Sync
    const wishlistCountEls = document.querySelectorAll('#wishlistCount, .wishlist-count, [data-wishlist-count]');
    const getWishlistItems = function() {
      try { return JSON.parse(localStorage.getItem('aura_wishlist') || localStorage.getItem('inklooma_wishlist') || '[]'); }
      catch(e) { return []; }
    };
    const currentWishlist = getWishlistItems();
    wishlistCountEls.forEach(el => {
      if (el) {
        el.textContent = currentWishlist.length;
        el.style.display = currentWishlist.length > 0 ? 'flex' : 'none';
      }
    });

    const openWishlistDrawerGlobal = function() {
      if (typeof window.updateWishlistUI === 'function') {
        window.updateWishlistUI();
      }
      const wishlistDrawer = document.getElementById('wishlistDrawer') || document.querySelector('.wishlist-drawer');
      const wishlistOverlay = document.getElementById('wishlistOverlay') || document.querySelector('.wishlist-drawer-overlay');

      if (typeof window.closeAuraCart === 'function') window.closeAuraCart();
      if (typeof closeCart === 'function') closeCart();

      if (wishlistDrawer) wishlistDrawer.classList.add('open');
      if (wishlistOverlay) wishlistOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    };

    const closeWishlistDrawerGlobal = function() {
      const wishlistDrawer = document.getElementById('wishlistDrawer') || document.querySelector('.wishlist-drawer');
      const wishlistOverlay = document.getElementById('wishlistOverlay') || document.querySelector('.wishlist-drawer-overlay');
      if (wishlistDrawer) wishlistDrawer.classList.remove('open');
      if (wishlistOverlay) wishlistOverlay.classList.remove('open');
      document.body.style.overflow = '';
    };

    window.openWishlist = openWishlistDrawerGlobal;
    window.closeWishlist = closeWishlistDrawerGlobal;
    window.openWishlistDrawer = openWishlistDrawerGlobal;
    window.closeWishlistDrawer = closeWishlistDrawerGlobal;

    // Global Event Delegation for Wishlist Header & Close Clicks
    document.addEventListener('click', function(e) {
      const wishTarget = e.target.closest('#wishlistBtn, a[href*="wishlist"], .header__icon[href*="wishlist"], [title="Wishlist"]');
      if (wishTarget && !wishTarget.classList.contains('inklooma-pdp-wishlist-btn')) {
        e.preventDefault();
        e.stopPropagation();
        openWishlistDrawerGlobal();
        return;
      }

      const wishClose = e.target.closest('#wishlistCloseBtn, #wishlistOverlay, #wishlistContinueBtn');
      if (wishClose) {
        e.preventDefault();
        closeWishlistDrawerGlobal();
        return;
      }

      const checkoutTarget = e.target.closest('#checkoutBtn, .shop-pay-btn, .g-pay-btn');
      if (checkoutTarget) {
        e.preventDefault();
        window.location.href = '/checkout';
        return;
      }
    });

    // 2. Free Shipping Bar Dynamic Calculation ($75 Threshold)
    const updateDynamicShippingBar = function() {
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cartData) {
          if (!cartData) return;
          const subtotal = (cartData.total_price || 0) / 100;
          const threshold = 75.00;
          const remaining = threshold - subtotal;
          const percent = Math.min(100, Math.max(0, (subtotal / threshold) * 100));

          const shippingBars = document.querySelectorAll('.cart-shipping-bar-fill, .shipping-progress-fill, [data-shipping-bar]');
          shippingBars.forEach(function(bar) {
            if (bar) bar.style.width = percent + '%';
          });

          const shippingTexts = document.querySelectorAll('.cart-shipping-text, .shipping-progress-text, [data-shipping-text], .drawer__shipping-message');
          shippingTexts.forEach(function(txt) {
            if (txt) {
              if (remaining <= 0) {
                txt.innerHTML = '🎉 You have unlocked <strong>FREE SHIPPING</strong>!';
              } else {
                txt.innerHTML = 'You are <strong>$' + remaining.toFixed(2) + '</strong> away from <strong>FREE SHIPPING</strong>';
              }
            }
          });
        })
        .catch(function(err) { console.log('Cart shipping bar fetch skipped/silent:', err); });
    };

    updateDynamicShippingBar();

    // 3. PDP Size Selector & Wishlist Button Injection (Only on Product Detail Pages)
    if (!isPDP) return;

    const productForm = document.querySelector('form[action*="/cart/add"]') || document.querySelector('.product-form') || document.querySelector('.product__info-container');
    if (!productForm) return;

    // Inject Size Selector if not present
    if (!document.querySelector('.inklooma-pdp-sizes') && !document.querySelector('.variant-radios')) {
      const sizeContainer = document.createElement('div');
      sizeContainer.className = 'inklooma-pdp-sizes';
      sizeContainer.style.cssText = 'margin: 18px 0; font-family: inherit; text-align: left;';
      
      const sizes = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
      let selectedPdpSize = 'M';

      sizeContainer.innerHTML = `
        <div style="font-size: 14px; font-weight: 800; color: #ffffff !important; margin-bottom: 10px; text-transform: uppercase; letter-spacing: 1px;">
          SIZE: <span id="pdpSelectedSizeLabel" style="font-weight: 900; color: #d4af37 !important; margin-left: 6px; text-shadow: 0 0 12px rgba(212, 175, 55, 0.4);">M</span>
        </div>
        <div style="display: flex; gap: 8px; flex-wrap: wrap;" id="pdpSizeButtons">
          ${sizes.map(size => `
            <button type="button" class="pdp-size-btn ${size === 'M' ? 'active' : ''}" data-size="${size}" style="
              min-width: 46px;
              height: 40px;
              padding: 0 16px;
              border: ${size === 'M' ? 'none' : '1px solid rgba(255, 255, 255, 0.25)'};
              background: ${size === 'M' ? 'linear-gradient(135deg, #f9f5e8 0%, #d4af37 40%, #b8860b 100%)' : '#15151a'};
              color: ${size === 'M' ? '#000000' : '#ffffff'};
              border-radius: 8px;
              font-weight: ${size === 'M' ? '900' : '700'};
              font-size: 13px;
              cursor: pointer;
              box-shadow: ${size === 'M' ? '0 4px 14px rgba(212, 175, 55, 0.4)' : 'none'};
              transition: all 0.25s ease;
            ">${size}</button>
          `).join('')}
        </div>
      `;

      const buyButtonsContainer = productForm.querySelector('.product-form__buttons') || productForm.querySelector('.product-form__input--quantity') || productForm.firstElementChild;
      if (buyButtonsContainer) {
        productForm.insertBefore(sizeContainer, buyButtonsContainer);
      } else {
        productForm.appendChild(sizeContainer);
      }

      const buttons = sizeContainer.querySelectorAll('.pdp-size-btn');
      buttons.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          buttons.forEach(b => {
            b.style.border = '1px solid rgba(255, 255, 255, 0.25)';
            b.style.background = '#15151a';
            b.style.color = '#ffffff';
            b.style.boxShadow = 'none';
            b.style.fontWeight = '700';
            b.classList.remove('active');
          });
          btn.style.border = 'none';
          btn.style.background = 'linear-gradient(135deg, #f9f5e8 0%, #d4af37 40%, #b8860b 100%)';
          btn.style.color = '#000000';
          btn.style.fontWeight = '900';
          btn.style.boxShadow = '0 4px 14px rgba(212, 175, 55, 0.4)';
          btn.classList.add('active');
          
          selectedPdpSize = btn.dataset.size;
          const label = document.getElementById('pdpSelectedSizeLabel');
          if (label) label.textContent = selectedPdpSize;

          let sizePropInput = productForm.querySelector('input[name="properties[Size]"]');
          if (!sizePropInput) {
            sizePropInput = document.createElement('input');
            sizePropInput.type = 'hidden';
            sizePropInput.name = 'properties[Size]';
            productForm.appendChild(sizePropInput);
          }
          sizePropInput.value = selectedPdpSize;
        });
      });
    }

    // Inject PDP Wishlist Button
    if (!document.querySelector('.inklooma-pdp-wishlist-btn')) {
      const submitBtn = productForm.querySelector('button[name="add"], .product-form__submit, [type="submit"]');
      if (submitBtn && submitBtn.parentNode) {
        const pdpWishlistBtn = document.createElement('button');
        pdpWishlistBtn.type = 'button';
        pdpWishlistBtn.className = 'inklooma-pdp-wishlist-btn';
        pdpWishlistBtn.title = 'Add to Wishlist';
        pdpWishlistBtn.style.cssText = `
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          border: 1.5px solid #cbd5e1;
          border-radius: 6px;
          background: #ffffff;
          color: #0f172a;
          font-size: 20px;
          cursor: pointer;
          margin-left: 10px;
          transition: all 0.2s ease;
        `;
        pdpWishlistBtn.innerHTML = '<i class="fa-regular fa-heart"></i>';

        const currentHandle = window.location.pathname.split('/products/')[1];
        if (currentWishlist.includes(currentHandle)) {
          pdpWishlistBtn.style.color = '#e11d48';
          pdpWishlistBtn.style.borderColor = '#e11d48';
          pdpWishlistBtn.innerHTML = '<i class="fa-solid fa-heart"></i>';
        }

        pdpWishlistBtn.addEventListener('click', function(e) {
          e.preventDefault();
          let list = [];
          try { list = JSON.parse(localStorage.getItem('aura_wishlist') || '[]'); } catch(err) {}

          let wishlistData = {};
          try { wishlistData = JSON.parse(localStorage.getItem('aura_wishlist_data') || '{}'); } catch(err) {}

          const currentTitle = document.querySelector('h1')?.textContent?.trim() || document.title;
          const currentImage = document.querySelector('meta[property="og:image"]')?.content || document.querySelector('.product__media img, .featured-media img, .product-single__photo')?.src || '';
          const priceText = document.querySelector('.price-item--sale, .price-item--regular, .product__price')?.textContent?.trim() || '$34.99';
          
          const idx = list.indexOf(currentHandle);
          if (idx > -1) {
            list.splice(idx, 1);
            delete wishlistData[currentHandle];
            pdpWishlistBtn.style.color = '#0f172a';
            pdpWishlistBtn.style.borderColor = '#cbd5e1';
            pdpWishlistBtn.innerHTML = '<i class="fa-regular fa-heart"></i>';
          } else {
            list.push(currentHandle);
            wishlistData[currentHandle] = {
              handle: currentHandle,
              title: currentTitle,
              image: currentImage,
              price: priceText
            };
            pdpWishlistBtn.style.color = '#e11d48';
            pdpWishlistBtn.style.borderColor = '#e11d48';
            pdpWishlistBtn.innerHTML = '<i class="fa-solid fa-heart"></i>';
          }
          localStorage.setItem('aura_wishlist', JSON.stringify(list));
          localStorage.setItem('inklooma_wishlist', JSON.stringify(list));
          localStorage.setItem('aura_wishlist_data', JSON.stringify(wishlistData));

          wishlistCountEls.forEach(el => {
            if (el) {
              el.textContent = list.length;
              el.style.display = list.length > 0 ? 'flex' : 'none';
            }
          });
        });

        submitBtn.parentNode.style.display = 'flex';
        submitBtn.parentNode.style.alignItems = 'center';
        submitBtn.parentNode.appendChild(pdpWishlistBtn);
      }
    }

    // 4. Bind Continue Shopping buttons to close Cart Drawer smoothly without page reload/redirect
    const bindContinueShopping = function() {
      const continueBtns = document.querySelectorAll('#emptyCartState a, #emptyCartState .btn, #emptyCartState .btn-checkout-yellow');
      continueBtns.forEach(function(btn) {
        if (btn.getAttribute('data-bound-continue')) return;
        btn.setAttribute('data-bound-continue', 'true');
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          if (typeof window.closeAuraCart === 'function') {
            window.closeAuraCart();
          } else if (typeof closeCart === 'function') {
            closeCart();
          } else {
            const overlay = document.getElementById('cartOverlay');
            const drawer = document.getElementById('cartDrawer');
            if (overlay) overlay.classList.remove('open');
            if (drawer) drawer.classList.remove('open');
            document.body.style.overflow = '';
          }
        });
      });
    };
    bindContinueShopping();
  }

  initPDPFeatures();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStorefront);
} else {
  initStorefront();
}

  // Active JS Color Fixer for Variant Pickers (SIZE: M)
  function fixVariantPickerColors() {
    const labels = document.querySelectorAll('.form__label, legend, .product-form__input legend, .variant-picker label, [class*="variant-label"]');
    labels.forEach(lbl => {
      if (lbl.tagName.toLowerCase() === 'label' && (lbl.getAttribute('for') || lbl.querySelector('input'))) return;
      lbl.style.setProperty('color', '#ffffff', 'important');
      lbl.style.setProperty('opacity', '1', 'important');
      lbl.style.setProperty('font-weight', '800', 'important');

      const valueSpans = lbl.querySelectorAll('span, b, strong');
      valueSpans.forEach(span => {
        span.style.setProperty('color', '#d4af37', 'important');
        span.style.setProperty('font-weight', '900', 'important');
      });
    });

    const optionLabels = document.querySelectorAll('.product-form__input label, fieldset label, variant-radios label');
    optionLabels.forEach(opt => {
      const forAttr = opt.getAttribute('for');
      const radio = forAttr ? document.getElementById(forAttr) : opt.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        opt.style.setProperty('background', 'linear-gradient(135deg, #f9f5e8 0%, #d4af37 40%, #b8860b 100%)', 'important');
        opt.style.setProperty('color', '#000000', 'important');
        opt.style.setProperty('border', 'none', 'important');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixVariantPickerColors);
  } else {
    fixVariantPickerColors();
  }
  setInterval(fixVariantPickerColors, 600);
  document.addEventListener('click', function() { setTimeout(fixVariantPickerColors, 50); });
  document.addEventListener('change', function() { setTimeout(fixVariantPickerColors, 50); });


  // --- ASSISTANCE FOOTER MODALS & INTERCEPTORS ---
  function initAssistanceModals() {
    if (!document.getElementById('trackShipmentOverlay')) {
      const trackModal = document.createElement('div');
      trackModal.id = 'trackShipmentOverlay';
      trackModal.className = 'aura-modal-overlay';
      trackModal.innerHTML = `
        <div class="aura-modal-content">
          <button type="button" class="aura-modal-close" onclick="document.getElementById('trackShipmentOverlay').classList.remove('open')">&times;</button>
          <h3><i class="fa-solid fa-truck-fast" style="color: #d4af37; margin-right: 8px;"></i> Track Your Shipment</h3>
          <p style="color: #a1a1aa; font-size: 13px; margin-bottom: 20px;">Enter your Order Number and Email address to get real-time tracking updates on your AURA order.</p>
          <form id="auraTrackForm" onsubmit="event.preventDefault(); alert('Order tracking status: Your order is being processed and will ship within 1-2 business days with DHL/USPS tracking link!');">
            <div style="margin-bottom: 14px; text-align: left;">
              <label style="display: block; font-size: 11px; font-weight: 800; color: #ffffff; text-transform: uppercase; margin-bottom: 6px;">Order Number (#)</label>
              <input type="text" placeholder="e.g. #AUR-10482" required style="width: 100%; background: #15151a; border: 1px solid rgba(255,255,255,0.2); border-radius: 8px; padding: 12px 14px; color: #fff; font-size: 14px; box-sizing: border-box;">
            </div>
            <div style="margin-bottom: 20px; text-align: left;">
              <label style="display: block; font-size: 11px; font-weight: 800; color: #ffffff; text-transform: uppercase; margin-bottom: 6px;">Email Address</label>
              <input type="email" placeholder="name@example.com" required style="width: 100%; background: #15151a; border: 1px solid rgba(255,255,255,0.2); border-radius: 8px; padding: 12px 14px; color: #fff; font-size: 14px; box-sizing: border-box;">
            </div>
            <button type="submit" style="width: 100%; background: linear-gradient(135deg, #f9f5e8 0%, #d4af37 40%, #b8860b 100%); color: #000; font-weight: 900; padding: 14px; border: none; border-radius: 10px; font-size: 13px; text-transform: uppercase; letter-spacing: 1px; cursor: pointer;">TRACK ORDER NOW</button>
          </form>
        </div>
      `;
      document.body.appendChild(trackModal);
    }

    if (!document.getElementById('faqsOverlay')) {
      const faqModal = document.createElement('div');
      faqModal.id = 'faqsOverlay';
      faqModal.className = 'aura-modal-overlay';
      faqModal.innerHTML = `
        <div class="aura-modal-content" style="max-width: 600px; text-align: left;">
          <button type="button" class="aura-modal-close" onclick="document.getElementById('faqsOverlay').classList.remove('open')">&times;</button>
          <h3 style="text-align: center;"><i class="fa-solid fa-shirt" style="color: #d4af37; margin-right: 8px;"></i> Print Quality FAQs</h3>
          <div style="margin-top: 20px;">
            <div style="margin-bottom: 16px; background: #15151a; border: 1px solid rgba(255,255,255,0.1); border-left: 3px solid #d4af37; border-radius: 8px; padding: 14px 18px;">
              <h4 style="color: #ffffff; font-weight: 800; margin: 0 0 6px 0; font-size: 14px;">What printing technology do you use?</h4>
              <p style="color: #a1a1aa; font-size: 13px; margin: 0; line-height: 1.6;">We use ultra-hd 3D dye sublimation printing. Ink molecules are thermally bonded into the polyester fibers so colors never peel, crack, or fade.</p>
            </div>
            <div style="margin-bottom: 16px; background: #15151a; border: 1px solid rgba(255,255,255,0.1); border-left: 3px solid #d4af37; border-radius: 8px; padding: 14px 18px;">
              <h4 style="color: #ffffff; font-weight: 800; margin: 0 0 6px 0; font-size: 14px;">How do I wash my graphic apparel?</h4>
              <p style="color: #a1a1aa; font-size: 13px; margin: 0; line-height: 1.6;">Machine wash cold with like colors inside-out. Tumble dry on low heat or hang dry for long-lasting vibrant artwork.</p>
            </div>
            <div style="margin-bottom: 0; background: #15151a; border: 1px solid rgba(255,255,255,0.1); border-left: 3px solid #d4af37; border-radius: 8px; padding: 14px 18px;">
              <h4 style="color: #ffffff; font-weight: 800; margin: 0 0 6px 0; font-size: 14px;">How long does production & shipping take?</h4>
              <p style="color: #a1a1aa; font-size: 13px; margin: 0; line-height: 1.6;">Production takes 2-4 business days. Standard US shipping takes 3-5 days; International shipping takes 7-12 days.</p>
            </div>
          </div>
        </div>
      `;
      document.body.appendChild(faqModal);
    }

    if (!document.getElementById('returnsOverlay')) {
      const returnModal = document.createElement('div');
      returnModal.id = 'returnsOverlay';
      returnModal.className = 'aura-modal-overlay';
      returnModal.innerHTML = `
        <div class="aura-modal-content" style="max-width: 540px; text-align: left;">
          <button type="button" class="aura-modal-close" onclick="document.getElementById('returnsOverlay').classList.remove('open')">&times;</button>
          <h3 style="text-align: center;"><i class="fa-solid fa-rotate-left" style="color: #d4af37; margin-right: 8px;"></i> Returns & Exchanges</h3>
          <div style="margin-top: 20px;">
            <p style="color: #ffffff; font-weight: 700; font-size: 14px; margin-bottom: 12px;">30-Day Money Back Guarantee</p>
            <p style="color: #a1a1aa; font-size: 13px; line-height: 1.6; margin-bottom: 16px;">If your apparel is defective, misprinted, or sized incorrectly, we offer hassle-free replacements or 100% full refunds within 30 days of delivery.</p>
            <div style="background: #15151a; border: 1px solid rgba(212,175,55,0.3); border-radius: 10px; padding: 16px; text-align: center;">
              <p style="color: #ffffff; font-size: 13px; margin: 0 0 8px 0;">To initiate a return, contact our support team:</p>
              ${window.shopSupportEmail ? `<a href="mailto:${window.shopSupportEmail}" style="color: #d4af37; font-weight: 900; font-size: 15px; text-decoration: underline;">${window.shopSupportEmail}</a>` : `<span style="color: #d4af37; font-weight: 900; font-size: 15px;">Contact Support Team</span>`}
            </div>
          </div>
        </div>
      `;
      document.body.appendChild(returnModal);
    }

    if (!document.getElementById('auraModalsCss')) {
      const modalStyle = document.createElement('style');
      modalStyle.id = 'auraModalsCss';
      modalStyle.textContent = `
        .aura-modal-overlay {
          position: fixed !important;
          top: 0 !important; left: 0 !important;
          width: 100vw !important; height: 100vh !important;
          background: rgba(0, 0, 0, 0.85) !important;
          backdrop-filter: blur(6px) !important;
          z-index: 9999999 !important;
          display: none !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .aura-modal-overlay.open {
          display: flex !important;
        }
        .aura-modal-content {
          background: #0d0d12 !important;
          border: 1px solid rgba(212, 175, 55, 0.4) !important;
          border-radius: 16px !important;
          padding: 30px !important;
          width: 90% !important;
          max-width: 480px !important;
          position: relative !important;
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.9) !important;
          color: #ffffff !important;
          font-family: 'Plus Jakarta Sans', system-ui, sans-serif !important;
        }
        .aura-modal-content h3 {
          font-size: 20px !important;
          font-weight: 900 !important;
          color: #ffffff !important;
          margin: 0 0 10px 0 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
        }
        .aura-modal-close {
          position: absolute !important;
          top: 14px !important; right: 18px !important;
          background: none !important;
          border: none !important;
          color: #ffffff !important;
          font-size: 24px !important;
          cursor: pointer !important;
          opacity: 0.7 !important;
          transition: opacity 0.2s !important;
        }
        .aura-modal-close:hover { opacity: 1 !important; color: #d4af37 !important; }
      `;
      document.head.appendChild(modalStyle);
    }
  }

  document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (!link) return;

    const href = (link.getAttribute('href') || '').toLowerCase();
    const text = (link.textContent || '').trim().toLowerCase();

    if (text.includes('size chart') || href.includes('size-chart')) {
      e.preventDefault();
      const chartOverlay = document.getElementById('sizeChartOverlay');
      if (chartOverlay) {
        chartOverlay.classList.add('open');
      } else {
        const btn = document.querySelector('.btn-size-chart');
        if (btn) btn.click();
      }
    } else if (text.includes('track') || href.includes('track')) {
      e.preventDefault();
      initAssistanceModals();
      const overlay = document.getElementById('trackShipmentOverlay');
      if (overlay) overlay.classList.add('open');
    } else if (text.includes('print quality') || text.includes('faq') || href.includes('faq')) {
      e.preventDefault();
      initAssistanceModals();
      const overlay = document.getElementById('faqsOverlay');
      if (overlay) overlay.classList.add('open');
    } else if (text.includes('return') || text.includes('exchange') || href.includes('return')) {
      e.preventDefault();
      initAssistanceModals();
      const overlay = document.getElementById('returnsOverlay');
      if (overlay) overlay.classList.add('open');
    }
  });


  // Auto-replace broken image in Size Chart Modal with HTML Table
  // Auto-replace broken image in Size Chart Modal with Shopify CDN Image + HTML Table
  function fixSizeChartModalContent() {
    const modalBody = document.querySelector('.size-chart-body');
    if (modalBody) {
      modalBody.innerHTML = `
        <div style="padding: 10px 0;">
          <div style="text-align: center; margin-bottom: 20px;">
            <img src="https://cdn.shopify.com/s/files/1/0773/6754/1909/files/aop_tshirt_size_chart.jpg?v=1784751161" alt="AOP T-Shirt Size Chart" style="width: 100%; max-width: 100%; height: auto; border-radius: 12px; border: 1px solid rgba(212, 175, 55, 0.4); box-shadow: 0 8px 25px rgba(0,0,0,0.8); display: block; margin: 0 auto;">
          </div>
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 13px; text-align: center; color: #ffffff;">
            <thead>
              <tr style="background: linear-gradient(135deg, #202028 0%, #121216 100%); border-bottom: 2px solid #d4af37;">
                <th style="padding: 12px 10px; color: #d4af37; font-weight: 900; text-transform: uppercase;">SIZE</th>
                <th style="padding: 12px 10px; color: #ffffff; font-weight: 800; text-transform: uppercase;">CHEST (IN)</th>
                <th style="padding: 12px 10px; color: #ffffff; font-weight: 800; text-transform: uppercase;">LENGTH (IN)</th>
                <th style="padding: 12px 10px; color: #ffffff; font-weight: 800; text-transform: uppercase;">SLEEVE (IN)</th>
              </tr>
            </thead>
            <tbody>
              <tr style="border-bottom: 1px solid rgba(255,255,255,0.08); background: #0f0f13;">
                <td style="padding: 12px 10px; font-weight: 900; color: #d4af37;">S</td>
                <td style="padding: 12px 10px; color: #ffffff;">20" (51 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">28" (71 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">8.5" (22 cm)</td>
              </tr>
              <tr style="border-bottom: 1px solid rgba(255,255,255,0.08); background: #15151a;">
                <td style="padding: 12px 10px; font-weight: 900; color: #d4af37;">M</td>
                <td style="padding: 12px 10px; color: #ffffff;">21" (53 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">29" (74 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">9.0" (23 cm)</td>
              </tr>
              <tr style="border-bottom: 1px solid rgba(255,255,255,0.08); background: #0f0f13;">
                <td style="padding: 12px 10px; font-weight: 900; color: #d4af37;">L</td>
                <td style="padding: 12px 10px; color: #ffffff;">23" (58 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">30" (76 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">9.5" (24 cm)</td>
              </tr>
              <tr style="border-bottom: 1px solid rgba(255,255,255,0.08); background: #15151a;">
                <td style="padding: 12px 10px; font-weight: 900; color: #d4af37;">XL</td>
                <td style="padding: 12px 10px; color: #ffffff;">25" (64 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">31" (79 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">10.0" (25 cm)</td>
              </tr>
              <tr style="border-bottom: 1px solid rgba(255,255,255,0.08); background: #0f0f13;">
                <td style="padding: 12px 10px; font-weight: 900; color: #d4af37;">2XL</td>
                <td style="padding: 12px 10px; color: #ffffff;">27" (69 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">32" (81 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">10.5" (27 cm)</td>
              </tr>
              <tr style="background: #15151a;">
                <td style="padding: 12px 10px; font-weight: 900; color: #d4af37;">3XL</td>
                <td style="padding: 12px 10px; color: #ffffff;">29" (74 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">33" (84 cm)</td>
                <td style="padding: 12px 10px; color: #ffffff;">11.0" (28 cm)</td>
              </tr>
            </tbody>
          </table>
          <div style="background: #121216; border: 1px solid rgba(212,175,55,0.3); border-radius: 10px; padding: 14px 18px; text-align: left;">
            <p style="color: #d4af37; font-weight: 800; font-size: 12px; text-transform: uppercase; margin: 0 0 6px 0; letter-spacing: 0.5px;">💡 Measuring Tips:</p>
            <p style="color: #a1a1aa; font-size: 12px; margin: 0; line-height: 1.6;">
              • <strong>Chest Width:</strong> Measure 1" below armhole flat across the chest.<br>
              • <strong>Length:</strong> Measure from highest point of shoulder seam to bottom hem.<br>
              • Fits true to size with standard unisex comfortable relaxed fit.
            </p>
          </div>
        </div>
      `;
    }
  }
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSizeChartModalContent);
  } else {
    fixSizeChartModalContent();
  }


  // Sync all cart keys globally
  window.syncAllCartKeys = function() {
    let c = [];
    try {
      c = JSON.parse(localStorage.getItem('aura_cart') || localStorage.getItem('mockCart') || localStorage.getItem('inklooma_cart') || localStorage.getItem('auraCart') || '[]');
    } catch(e) {}
    window.cart = c;
    if (typeof window.refreshAuraCartData === 'function') {
      window.refreshAuraCartData();
    }
  };
  window.syncAllCartKeys();


  // Sync internal cart array from storage
  window.syncCartFromStorage = function() {
    try {
      cart = JSON.parse(localStorage.getItem('aura_cart') || localStorage.getItem('mockCart') || localStorage.getItem('inklooma_cart') || localStorage.getItem('auraCart') || '[]');
    } catch(e) {}
  };


  // Bind global checkout button listener
  document.addEventListener('click', function(e) {
    const checkoutTarget = e.target.closest('#checkoutBtn, .btn-checkout-yellow, .shop-pay-btn, .g-pay-btn, [href="/checkout"], [href*="checkout"]');
    if (checkoutTarget) {
      if (typeof window.handleShopifyCheckout === 'function') {
        window.handleShopifyCheckout(e);
      }
    }
  });


  // Intercept standard Shopify Product Page form submissions to open custom Cart Drawer
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form && (form.action && form.action.includes('/cart/add'))) {
      setTimeout(function() {
        if (typeof window.refreshAuraCartData === 'function') window.refreshAuraCartData();
        if (typeof window.openAuraCart === 'function') window.openAuraCart();
      }, 500);
    }
  });

  // Ensure cart data is synced from storage on load
  if (typeof window.syncCartFromStorage === 'function') {
    window.syncCartFromStorage();
  }


  // Intercept Sticky Recommendation Bar clicks and sync with main PDP Product Form & Cart Drawer
  document.addEventListener('click', function(e) {
    const stickyBtn = e.target.closest('.sticky-atc-bar button, .inklooma-sticky-bar button, [class*="sticky-atc"] button, [class*="sticky-bar"] button, [class*="recommendation"] button, .sticky-atc-bar a, [class*="sticky-atc"] a');
    if (stickyBtn) {
      const parentForm = stickyBtn.closest('form[action*="/cart/add"], form.shopify-product-form') || document.querySelector('form[action*="/cart/add"]');
      if (parentForm) {
        const mainSubmitBtn = parentForm.querySelector('button[name="add"], button[type="submit"], input[type="submit"], .product-form__submit');
        if (mainSubmitBtn && mainSubmitBtn !== stickyBtn) {
          e.preventDefault();
          mainSubmitBtn.click();
        }
      }
    }
  });

})();
